
import { Language } from '../types';

type Translations = Record<Language, Record<string, string>>;

export const TRANSLATIONS: Translations = {
  it: {
    no_rider_found: "Nessun Rider ha accettato l'ordine entro 30 minuti. Puoi riprovare a inviare la richiesta o gestirlo internamente.",
    status_open: "Aperto ora",
    status_closed: "Chiuso ora",
    closed_extra: "Chiusura Straordinaria", 
    loading: "Caricamento...",
    hours: "Orari",
    about: "Chi Siamo",
    contact: "Contattaci",
    store_location: "Sede Locale",
    events: "Eventos",
    dine_in: "Mangia Qui",
    dine_in_desc: "Hai scelto di consumare l'ordine al tavolo.",
    dine_in_desc_retail: "Servizio o consulenza in sede.",
    take_away: "Porto Via",
    take_away_desc: "Hai scelto di venire a RITIRARE TU l'ordine.",
    take_away_desc_retail: "Prenota i prodotti e passa a ritirarli.",
    delivery: "Consegna a Domicilio",
    delivery_desc: "Un nostro rider ti consegnerà l'ordine a casa.",
    delivery_desc_retail: "Spedizione o consegna all'indirizzo.",
    not_available: "Non Disponibile",
    suspended: "SOSPESO",
    temp_unavailable: "MOMENTANEAMENTE NON DISPONIBILE", 
    closed_msg: "Siamo Chiusi",
    closed_desc: "Il locale è attualmente chiuso.",
    browse_menu: "Sfoglia Menu",
    browse_catalog: "Sfoglia Catalogo",
    choose_menu_title: "Scegli il tuo menu", // NEW
    choose_catalog_title: "Il Nostro Catalogo", // NEW
    address_title: "Dove consegniamo?",
    address_title_retail: "Indirizzo Spedizione?",
    address_step1: "Passo 1: Via o Piazza",
    address_step2: "Passo 2: Città / Paese",
    address_step3: "Passo 3: Numero Civico",
    next: "Avanti",
    confirm_address: "Conferma Indirizzo",
    verifying: "Verifica...",
    address_confirmed: "Indirizzo Confermato!",
    delivery_cost: "Costo Consegna",
    shipping_cost: "Costo Spedizione",
    min_order: "Ordine Minimo",
    go_to_menu: "Vai al Menu",
    go_to_catalog: "Vai al Catalogo",
    out_of_zone: "Fuori Zona",
    out_of_zone_desc: "L'indirizzo inserito sembra essere fuori dalla nostra zona di servizio.",
    close: "Chiudi",
    confirm: "Conferma",
    cancel: "Annulla",
    wait_time: "Attesa stimata",
    warning: "Attenzione",
    warning_takeaway: "NON è la consegna a domicilio.",
    supplement: "Supplemento",
    send_msg: "Invia Messaggio",
    write_us: "Scrivici",
    your_name: "Il tuo nome",
    your_phone: "Telefono (per ricevere risposta)",
    order_id_opt: "Codice Ordine (Opzionale)",
    msg_placeholder: "Scrivi qui il tuo messaggio...",
    msg_warn: "Importante: Non chiediamo registrazione. Se non inserisci il numero, non potremo risponderti!",
    kiosk_mode: "Modalità Chiosco",
    confirm_removal: "Conferma rimozione",
    confirm_removal_message: "Vuoi davvero rimuovere {item}?",
    cart_title: "Carrello",
    cart_empty: "Il carrello è vuoto",
    start_ordering: "Inizia a ordinare",
    promo_code: "Codice Sconto",
    apply: "Applica",
    coupon_applied: "Coupon applicato!",
    shipping: "Spedizione",
    free: "Gratis",
    total_order: "Totale Ordine",
    proceed: "Procedi",
    who_orders: "Chi ordina?",
    table_number: "Numero Tavolo",
    payment_method: "Metodo di pagamento",
    kitchen_notes: "Note per la cucina",
    kitchen_notes_placeholder: "Es. Niente prezzemolo, ben cotto...",
    send_order: "Invia Ordine",
    add: "Aggiungi",
    update: "Aggiorna",
    total: "Totale",
    how_to_serve: "Come lo serviamo?",
    serve_desc: "Scegli come preferisci ricevere questo prodotto.",
    plate: "Al Piatto",
    disposable: "Monouso / Box",
    best_sellers: "I più venduti e Consigliati",
    quick_add: "Aggiungi al volo",
    order_again: "Ordina come l'ultima volta",
    search_products: "Cerca prodotti...",
    search_results: "Risultati Ricerca",
    no_results: "Nessun prodotto trovato.",
    discover: "Scopri",
    scroll_for_ingredients: "Scorri per gli ingredienti",
    max_ingredients_limit: "Massimo {count} varianti!",
    combination_applied: "Combinazione applicata!",
    order_updated: "Ordine aggiornato!",
    item_added: "{item} aggiunto!",
    added_label: "Aggiunto: {item}",
    // RECEIPT
    receipt_copy: "Copia Cliente",
    receipt_payment: "PAGAMENTO",
    receipt_table: "TAVOLO",
    receipt_takeaway: "ASPORTO",
    receipt_delivery: "CONSEGNA",
    receipt_notes: "Note",
    without: "SENZA",
    // LOYALTY & BANNERS
    loyalty_title: "Sconto di {value}!",
    loyalty_reward_badge: "PREMIO FEDELTÀ", // DEFAULT TITLE
    loyalty_desc: "Guadagna punti ad ogni ordine!", // DEFAULT DESC
    loyalty_card_info: "Il tuo numero è la tua tessera",
    super_reward_active: "{title} Attivo!",
    super_reward_days_left: "Consegne gratuite attive ancora per {days} giorni.",
    expires_on: "Scade il",
    goal: "Obiettivo",
    points_progress: "Punti",
    points_missing: "Ti mancano solo {points} punti per sbloccare il premio!",
    goal_reached: "Obiettivo Raggiunto! Vai al carrello per attivarlo.",
    promo_code_label: "CODICE",
    retail_pickup: "Ritiro in Sede",
    retail_delivery: "Spedizione / Consegna",
    loyalty_enter_number: "Inserisci il numero e raccogli punti per vincerlo!",
    super_reward_default: "Super Premio",
    // LOYALTY CHECK BALANCE
    check_points_btn: "Controlla Saldo",
    check_points_modal_title: "Inserisci il tuo numero",
    check_points_modal_desc: "Inserisci il cellulare usato per gli ordini precedenti per recuperare il saldo punti.",
    check_points_verify: "Controlla Punti",
    check_points_verifying: "Verifica in corso...",
    check_points_error_invalid: "Numero non valido",
    check_points_error_not_found: "Numero non trovato. Fai il primo ordine per attivare la tessera!",
    // NEW LOYALTY CART PROMPTS
    loyalty_prompt_title: "Non perderti i punti! 🎁",
    loyalty_prompt_desc: "Inserisci il tuo numero per accumulare punti e ottenere <strong>premi esclusivi</strong>.",
    loyalty_your_phone_placeholder: "Il tuo cellulare",
    loyalty_points_balance: "Hai {points} Punti!",
    loyalty_super_reward_btn: "Attiva Super Premio",
    // MISSING LOYALTY KEYS
    free_product: "Prodotto Omaggio",
    added_to_cart: "Aggiunto al carrello",
    loyalty_discount: "Sconto Fedeltà",
    points_redeemed: "Punti Usati",
    points_earned: "Punti Guadagnati",
    loyalty_balance: "Saldo Punti",
    // DYNAMIC RULE TEXTS
    loyalty_rule_spend: "Ogni {amount}€ = 1 Punto.",
    loyalty_rule_order: "{amount} Punti per ogni ordine.",
    loyalty_claim_reward: "Raccogli {amount} punti per un premio!",
    // ADDRESS WARNING
    wrong_address_warning: "Attenzione: Se l'indirizzo di consegna reale differisce da quello inserito (es. civico errato che cambia zona), il fattorino potrà richiedere un supplemento.",
    // MARKETING
    marketing_btn: "Offerte & Novità",
    whats_new: "Cosa c'è di nuovo",
    marketing_offer: "Offerta",
    marketing_offers: "Offerte",
    marketing_news: "Novità",
    no_variants_title: "Senza Varianti",
    no_variants_desc: "Hai scelto di aggiungere il prodotto senza selezionare alcuna variante o aggiunta. Sei sicuro di voler procedere?",
    marketing_special_offer: "Offerta Speciale",
    marketing_featured_products: "Prodotti in Evidenza",
    marketing_get_discount: "Ottieni Codice Sconto",
    marketing_order_now: "Ordina Ora",
    marketing_discount_applied: "Lo sconto ({code}) sarà applicato al checkout. È monouso e scadrà tra 1 ora.",
    marketing_add_cart: "Aggiungi al Carrello",
    // EXTENDED MISSING STRINGS
    my_orders: "I Miei Ordini",
    my_orders_desc: "Cronologia dei tuoi ordini recenti in questo negozio.",
    my_orders_loading: "Caricamento ordini...",
    my_orders_empty: "Nessun ordine recente trovato su questo dispositivo.",
    order_num: "Ordine #{id}",
    reorder: "Riordina",
    edit_order_time_limit: "Modifica Ordine (Entro 3 min)",
    reorder_modal_title: "Scegli la Modalità",
    reorder_modal_desc: "Come vuoi ricevere il tuo ordine?",
    order_status_completed: "Completato",
    order_status_cancelled: "Annullato",
    order_status_delivering: "In Consegna",
    order_status_preparing: "In Preparazione",
    context_delivery: "Domicilio",
    context_takeaway: "Asporto",
    context_dinein: "Tavolo",
    go_to_cart: "Vai al Carrello",
    cart_subtotal: "Subtotale",
    cart_delivery_fee: "Consegna",
    surge_fee: "Maggiorazione Orario/Festivo",
    takeaway_fee: "Supplemento Asporto",
    small_order_fee: "Supplemento Ordine Minimo",
    app_discount_label: "Sconto App",
    promo_quantity_discount_label: "Sconto Quantità Promozionale",
    items_count: "({count} art.)",
    points_earned_badge: "+{points} Punti",
    update_order_btn: "Aggiorna Ordine",
    free_delivery_super_reward: "Consegna Gratis (Super Reward)",
    mandatory_choice_alert: "⚠️ ATTENZIONE: SCELTA OBBLIGATORIA\n\nDevi selezionare almeno {quantity} {category}.\nTe ne mancano: {missing}.",
    missing_free_title: "Aggiunte Gratis Disponibili",
    missing_free_desc: "Questo prodotto ha delle aggiunte comprese nel prezzo che non hai selezionato ({categories}). Quale preferisci aggiungere, oppure vuoi procedere senza?",
    name_modal_title: "Come ti chiami?",
    name_modal_desc: "Inserisci il tuo nome per l'ordine.",
    name_modal_placeholder: "Il tuo nome...",
    intercom_modal_title: "Dettagli Consegna",
    intercom_modal_desc: "Inserisci nome sul citofono, scala o piano.",
    intercom_modal_placeholder: "Es. Scala B, Int. 4...",
    phone_modal_title_mandatory: "Numero di Telefono",
    phone_modal_title_optional: "Numero Cellulare (Consigliato)",
    phone_modal_desc_mandatory: "Richiesto per la consegna o per inviarti il link di pagamento.",
    phone_modal_desc_optional: "Se lo salti non riceverai l'avviso per ritirare il tuo ordine pronto e perderai i Punti Fedeltà!",
    phone_modal_confirm_btn: "Conferma Numero",
    phone_modal_skip_btn: "Continua senza Numero (Perdo i punti)",
    birthday_modal_title: "Quando è il tuo compleanno?",
    birthday_modal_desc: "Inserisci il giorno e il mese per ricevere un regalo!",
    birthday_modal_gdpr: "(In rispetto del GDPR non raccogliamo l'anno di nascita)",
    birthday_modal_skip_btn: "Non voglio dirlo",
    privacy_modal_title: "Ultimo step!",
    privacy_modal_desc: "Per proseguire è necessario accettare la privacy policy.",
    privacy_checkbox_text: "Ho letto e accetto la",
    privacy_checkbox_mandatory: "(Obbligatorio)",
    privacy_marketing_text: "Vuoi ricevere promozioni e sconti quando disponibili? (Facoltativo)",
    privacy_confirm_btn: "Conferma e Invia Ordine",
    privacy_error_alert: "Devi accettare la Privacy Policy per continuare.",
    payment_method_title: "Metodo di Pagamento",
    payment_method_desc: "Come preferisci pagare?",
    payment_cash: "Contanti",
    payment_cash_delivery: "Contrassegno (Alla Consegna)",
    payment_cash_pickup: "Paga al Ritiro (In Sede)",
    payment_pos_delivery: "POS (Alla Consegna)",
    payment_pos_store: "POS / Cassa",
    payment_pos_link: "POS / Link di Pagamento",
    payment_disabled_badge: "Disattivo"
  },
  en: {
    no_rider_found: "No Rider accepted the order within 30 minutes. You can retry sending the request or handle it internally.",
    status_open: "Open Now",
    status_closed: "Closed Now",
    closed_extra: "Special Closure",
    loading: "Loading...",
    hours: "Hours",
    about: "About Us",
    contact: "Contact Us",
    store_location: "Our Location",
    events: "Events",
    dine_in: "Dine In",
    dine_in_desc: "You chose to eat at the table.",
    dine_in_desc_retail: "Service or consultation on site.",
    take_away: "Take Away",
    take_away_desc: "You chose to PICK UP the order yourself.",
    take_away_desc_retail: "Reserve items and pick them up.",
    delivery: "Delivery",
    delivery_desc: "A rider will deliver your order to your home.",
    delivery_desc_retail: "Shipping or delivery to address.",
    not_available: "Not Available",
    suspended: "SUSPENDED",
    temp_unavailable: "TEMPORARILY UNAVAILABLE",
    closed_msg: "We are Closed",
    closed_desc: "The shop is currently closed.",
    browse_menu: "Browse Menu",
    browse_catalog: "Browse Catalog",
    choose_menu_title: "Choose your menu", // NEW
    choose_catalog_title: "Our Catalog", // NEW
    address_title: "Where to deliver?",
    address_title_retail: "Shipping Address?",
    address_step1: "Step 1: Street or Square",
    address_step2: "Step 2: City / Town",
    address_step3: "Step 3: House Number",
    next: "Next",
    confirm_address: "Confirm Address",
    verifying: "Verifying...",
    address_confirmed: "Address Confirmed!",
    delivery_cost: "Delivery Fee",
    shipping_cost: "Shipping Cost",
    min_order: "Min Order",
    go_to_menu: "Go to Menu",
    go_to_catalog: "Go to Catalog",
    out_of_zone: "Out of Zone",
    out_of_zone_desc: "The address seems to be outside our service area.",
    close: "Close",
    confirm: "Confirm",
    cancel: "Cancel",
    wait_time: "Est. Wait Time",
    warning: "Warning",
    warning_takeaway: "This is NOT home delivery.",
    supplement: "Extra Fee",
    send_msg: "Send Message",
    write_us: "Write to us",
    your_name: "Your Name",
    your_phone: "Phone (for reply)",
    order_id_opt: "Order ID (Optional)",
    msg_placeholder: "Write your message here...",
    msg_warn: "Important: We don't ask for registration. If you don't enter your number, we can't reply!",
    kiosk_mode: "Kiosk Mode",
    confirm_removal: "Confirm removal",
    confirm_removal_message: "Are you sure you want to remove {item}?",
    cart_title: "Cart",
    cart_empty: "Your cart is empty",
    start_ordering: "Start Ordering",
    promo_code: "Promo Code",
    apply: "Apply",
    coupon_applied: "Coupon Applied!",
    shipping: "Shipping",
    free: "Free",
    total_order: "Order Total",
    proceed: "Proceed",
    who_orders: "Who is ordering?",
    table_number: "Table Number",
    payment_method: "Payment Method",
    kitchen_notes: "Kitchen Notes",
    kitchen_notes_placeholder: "Ex. No parsley, well done...",
    send_order: "Send Order",
    add: "Add",
    update: "Update",
    total: "Total",
    how_to_serve: "How to serve?",
    serve_desc: "Choose how you prefer to receive this item.",
    plate: "Plated",
    disposable: "Takeaway Box",
    best_sellers: "Best Sellers & Recommended",
    quick_add: "Quick Add",
    order_again: "Order Again",
    search_products: "Search products...",
    search_results: "Search Results",
    no_results: "No products found.",
    discover: "Discover",
    scroll_for_ingredients: "Scroll for ingredients",
    max_ingredients_limit: "Max {count} variants!",
    combination_applied: "Combination applied!",
    order_updated: "Order updated!",
    item_added: "{item} added!",
    added_label: "Added: {item}",
    // RECEIPT
    receipt_copy: "Customer Copy",
    receipt_payment: "PAYMENT",
    receipt_table: "TABLE",
    receipt_takeaway: "TAKEAWAY",
    receipt_delivery: "DELIVERY",
    receipt_notes: "Notes",
    without: "NO",
    // LOYALTY & BANNERS
    loyalty_title: "Discount of {value}!",
    loyalty_reward_badge: "LOYALTY REWARD", // DEFAULT TITLE
    loyalty_desc: "Earn points with every order!", // DEFAULT DESC
    loyalty_card_info: "Your phone number is your card",
    super_reward_active: "{title} Active!",
    super_reward_days_left: "Free delivery active for {days} more days.",
    expires_on: "Expires on",
    goal: "Goal",
    points_progress: "Points",
    points_missing: "You only need {points} more points to unlock the reward!",
    goal_reached: "Goal Reached! Go to cart to activate it.",
    promo_code_label: "CODE",
    retail_pickup: "Store Pickup",
    retail_delivery: "Shipping / Delivery",
    loyalty_enter_number: "Enter your number to earn points and win!",
    super_reward_default: "Super Reward",
    // LOYALTY CHECK BALANCE
    check_points_btn: "Check Balance",
    check_points_modal_title: "Enter your number",
    check_points_modal_desc: "Enter the mobile number used for previous orders to retrieve your points balance.",
    check_points_verify: "Check Points",
    check_points_verifying: "Verifying...",
    check_points_error_invalid: "Invalid number",
    check_points_error_not_found: "Number not found. Place your first order to activate the card!",
    // NEW LOYALTY CART PROMPTS
    loyalty_prompt_title: "Don't miss the points! 🎁",
    loyalty_prompt_desc: "Enter your number to collect points and get <strong>exclusive rewards</strong>.",
    loyalty_your_phone_placeholder: "Your mobile number",
    loyalty_points_balance: "You have {points} Points!",
    loyalty_super_reward_btn: "Activate Super Reward",
    // MISSING LOYALTY KEYS
    free_product: "Free Product",
    added_to_cart: "Added to cart",
    loyalty_discount: "Loyalty Discount",
    points_redeemed: "Points Redeemed",
    points_earned: "Points Earned",
    loyalty_balance: "Points Balance",
    // DYNAMIC RULE TEXTS
    loyalty_rule_spend: "Every {amount}€ = 1 Point.",
    loyalty_rule_order: "{amount} Points per order.",
    loyalty_claim_reward: "Collect {amount} points for a reward!",
    // ADDRESS WARNING
    wrong_address_warning: "Warning: If the actual delivery address differs from the entered one (e.g. wrong number changes the zone), the rider may request a surcharge.",
    // MARKETING
    marketing_btn: "Offers & News",
    whats_new: "What's new",
    marketing_offer: "Offer",
    marketing_offers: "Offers",
    marketing_news: "News",
    no_variants_title: "No Variants",
    no_variants_desc: "You chose to add the product without selecting any variants or extras. Are you sure you want to proceed?",
    marketing_special_offer: "Special Offer",
    marketing_featured_products: "Featured Products",
    marketing_get_discount: "Get Discount Code",
    marketing_order_now: "Order Now",
    marketing_discount_applied: "Discount ({code}) will be applied at checkout. It is single-use and expires in 1 hour.",
    marketing_add_cart: "Add to Cart",
    // EXTENDED MISSING STRINGS
    my_orders: "My Orders",
    my_orders_desc: "History of your recent orders at this store.",
    my_orders_loading: "Loading orders...",
    my_orders_empty: "No recent orders found on this device.",
    order_num: "Order #{id}",
    reorder: "Reorder",
    edit_order_time_limit: "Edit Order (Within 3 min)",
    reorder_modal_title: "Choose Order Type",
    reorder_modal_desc: "How would you like to receive your order?",
    order_status_completed: "Completed",
    order_status_cancelled: "Cancelled",
    order_status_delivering: "Out for Delivery",
    order_status_preparing: "In Kitchen",
    context_delivery: "Delivery",
    context_takeaway: "Takeaway",
    context_dinein: "Table",
    go_to_cart: "Go to Cart",
    cart_subtotal: "Subtotal",
    cart_delivery_fee: "Delivery",
    surge_fee: "Holiday / Peak Surcharge",
    takeaway_fee: "Takeaway Surcharge",
    small_order_fee: "Small Order Surcharge",
    app_discount_label: "App Discount",
    promo_quantity_discount_label: "Quantity Promo Discount",
    items_count: "({count} items)",
    points_earned_badge: "+{points} Points",
    update_order_btn: "Update Order",
    free_delivery_super_reward: "Free Delivery (Super Reward)",
    mandatory_choice_alert: "⚠️ MANDATORY CHOICE\n\nYou must select at least {quantity} {category}.\nMissing: {missing}.",
    missing_free_title: "Free Options Available",
    missing_free_desc: "This item includes free options you haven't selected ({categories}). Which would you like to add, or proceed without?",
    name_modal_title: "What's your name?",
    name_modal_desc: "Enter your name for the order.",
    name_modal_placeholder: "Your name...",
    intercom_modal_title: "Delivery Details",
    intercom_modal_desc: "Enter intercom name, staircase or floor.",
    intercom_modal_placeholder: "E.g. Apt 4B, 2nd floor...",
    phone_modal_title_mandatory: "Phone Number",
    phone_modal_title_optional: "Mobile Number (Recommended)",
    phone_modal_desc_mandatory: "Required for delivery or payment links.",
    phone_modal_desc_optional: "If skipped you will miss order ready updates and loyalty points!",
    phone_modal_confirm_btn: "Confirm Phone",
    phone_modal_skip_btn: "Continue without phone (Lose points)",
    birthday_modal_title: "When is your birthday?",
    birthday_modal_desc: "Enter your day and month to receive a special gift!",
    birthday_modal_gdpr: "(For GDPR privacy we do not collect birth year)",
    birthday_modal_skip_btn: "Skip",
    privacy_modal_title: "Last Step!",
    privacy_modal_desc: "Please accept the privacy policy to continue.",
    privacy_checkbox_text: "I have read and accept the",
    privacy_checkbox_mandatory: "(Required)",
    privacy_marketing_text: "Receive exclusive promotions and discounts? (Optional)",
    privacy_confirm_btn: "Confirm and Place Order",
    privacy_error_alert: "You must accept the Privacy Policy to proceed.",
    payment_method_title: "Payment Method",
    payment_method_desc: "How would you like to pay?",
    payment_cash: "Cash",
    payment_cash_delivery: "Cash on Delivery",
    payment_cash_pickup: "Pay at Pickup",
    payment_pos_delivery: "POS (On Delivery)",
    payment_pos_store: "POS / Counter",
    payment_pos_link: "POS / Payment Link",
    payment_disabled_badge: "Disabled"
  },
  fr: {
    no_rider_found: "Aucun Rider n'a accepté l'ordre dans les 30 minutes. Vous pouvez réessayer d'envoyer la demande ou le gérer en interne.",
    status_open: "Ouvert",
    status_closed: "Fermé",
    closed_extra: "Fermeture Exceptionnelle",
    loading: "Chargement...",
    hours: "Horaires",
    about: "À Propos",
    contact: "Contactez-nous",
    store_location: "Notre Adresse",
    events: "Événements",
    dine_in: "Sur Place",
    dine_in_desc: "Vous avez choisi de manger à table.",
    dine_in_desc_retail: "Service ou consultation sur place.",
    take_away: "À Emporter",
    take_away_desc: "Vous venez RÉCUPÉRER votre commande.",
    take_away_desc_retail: "Réservez et récupérez sur place.",
    delivery: "Livraison",
    delivery_desc: "Un livreur vous apportera votre commande.",
    delivery_desc_retail: "Expédition ou livraison à domicile.",
    not_available: "Indisponible",
    suspended: "SUSPENDU",
    temp_unavailable: "TEMPORAIREMENT INDISPONIBLE",
    closed_msg: "Nous sommes Fermés",
    closed_desc: "Le magasin est actuellement fermé.",
    browse_menu: "Voir le Menu",
    browse_catalog: "Voir le Catalogue",
    choose_menu_title: "Choisissez votre menu", // NEW
    choose_catalog_title: "Notre Catalogue", // NEW
    address_title: "Où livrer ?",
    address_title_retail: "Adresse de livraison ?",
    address_step1: "Étape 1: Rue",
    address_step2: "Étape 2: Ville",
    address_step3: "Étape 3: Numéro",
    next: "Suivant",
    confirm_address: "Confirmer l'adresse",
    verifying: "Vérification...",
    address_confirmed: "Adresse Confirmée !",
    delivery_cost: "Frais de livraison",
    shipping_cost: "Frais d'expédition",
    min_order: "Commande Min",
    go_to_menu: "Aller au Menu",
    go_to_catalog: "Aller au Catalogue",
    out_of_zone: "Hors Zone",
    out_of_zone_desc: "L'adresse semble être hors de notre zone de service.",
    close: "Fermer",
    confirm: "Confirmer",
    cancel: "Annuler",
    wait_time: "Attente estimée",
    warning: "Attention",
    warning_takeaway: "Ce n'est PAS une livraison à domicile.",
    supplement: "Supplément",
    send_msg: "Envoyer Message",
    write_us: "Écrivez-nous",
    your_name: "Votre Nom",
    your_phone: "Téléphone (pour réponse)",
    order_id_opt: "ID Commande (Optionnel)",
    msg_placeholder: "Écrivez votre message ici...",
    msg_warn: "Important: Pas d'inscription requise. Sans numéro, nous ne pouvons pas répondre !",
    kiosk_mode: "Mode Kiosque",
    confirm_removal: "Confirmer la suppression",
    confirm_removal_message: "Voulez-vous vraiment supprimer {item} ?",
    cart_title: "Panier",
    cart_empty: "Votre panier est vide",
    start_ordering: "Commencer",
    promo_code: "Code Promo",
    apply: "Appliquer",
    coupon_applied: "Coupon Appliqué !",
    shipping: "Expédition",
    free: "Gratuit",
    total_order: "Total Commande",
    proceed: "Procéder",
    who_orders: "Qui commande ?",
    table_number: "Numéro de Table",
    payment_method: "Mode de paiement",
    kitchen_notes: "Notes pour la cuisine",
    kitchen_notes_placeholder: "Ex. Pas de persil, bien cuit...",
    send_order: "Envoyer Commande",
    add: "Ajouter",
    update: "Mettre à jour",
    total: "Total",
    how_to_serve: "Comment servir ?",
    serve_desc: "Choisissez comment vous préférez recevoir cet article.",
    plate: "Sur Assiette",
    disposable: "Emballage Jetable",
    best_sellers: "Meilleures Ventes & Recommandés",
    quick_add: "Ajout Rapide",
    order_again: "Commander à nouveau",
    search_products: "Chercher produits...",
    search_results: "Résultats Recherche",
    no_results: "Aucun produit trouvé.",
    discover: "Découvrir",
    scroll_for_ingredients: "Faites défiler pour les ingrédients",
    max_ingredients_limit: "Max {count} variantes !",
    combination_applied: "Combinaison appliquée !",
    order_updated: "Commande mise à jour !",
    item_added: "{item} ajouté !",
    added_label: "Ajouté : {item}",
    // RECEIPT
    receipt_copy: "Copie Client",
    receipt_payment: "PAIEMENT",
    receipt_table: "TABLE",
    receipt_takeaway: "EMPORTER",
    receipt_delivery: "LIVRAISON",
    receipt_notes: "Notes",
    without: "SANS",
    // LOYALTY & BANNERS
    loyalty_title: "Remise de {value} !",
    loyalty_reward_badge: "RÉCOMPENSE FIDÉLITÉ", // DEFAULT TITLE
    loyalty_desc: "Gagnez des points à chaque commande !", // DEFAULT DESC
    loyalty_card_info: "Votre numéro est votre carte",
    super_reward_active: "{title} Actif !",
    super_reward_days_left: "Livraison gratuite active pour encore {days} jours.",
    expires_on: "Expire le",
    goal: "Objectif",
    points_progress: "Points",
    points_missing: "Il ne vous manque que {points} points pour débloquer la récompense !",
    goal_reached: "Objectif Atteint ! Allez au panier pour l'activer.",
    promo_code_label: "CODE",
    retail_pickup: "Retrait en Magasin",
    retail_delivery: "Expédition / Livraison",
    loyalty_enter_number: "Entrez votre numéro pour gagner des points !",
    super_reward_default: "Super Récompense",
    // LOYALTY CHECK BALANCE
    check_points_btn: "Voir Solde",
    check_points_modal_title: "Entrez votre numéro",
    check_points_modal_desc: "Entrez le numéro de portable utilisé pour les commandes précédentes pour récupérer le solde de points.",
    check_points_verify: "Vérifier Points",
    check_points_verifying: "Vérification...",
    check_points_error_invalid: "Numéro invalide",
    check_points_error_not_found: "Numéro introuvable. Passez votre première commande pour activer la carte !",
    // NEW LOYALTY CART PROMPTS
    loyalty_prompt_title: "Ne manquez pas les points ! 🎁",
    loyalty_prompt_desc: "Entrez votre numéro pour cumuler des points et obtenir des <strong>récompenses exclusives</strong>.",
    loyalty_your_phone_placeholder: "Votre portable",
    loyalty_points_balance: "Vous avez {points} Points !",
    loyalty_super_reward_btn: "Activer Super Récompense",
    // MISSING LOYALTY KEYS
    free_product: "Produit Offert",
    added_to_cart: "Ajouté au panier",
    loyalty_discount: "Remise Fidélité",
    points_redeemed: "Points Utilisés",
    points_earned: "Points Gagnés",
    loyalty_balance: "Solde Points",
    // DYNAMIC RULE TEXTS
    loyalty_rule_spend: "Chaque {amount}€ = 1 Point.",
    loyalty_rule_order: "{amount} Points par commande.",
    loyalty_claim_reward: "Collectez {amount} points pour une récompense !",
    // ADDRESS WARNING
    wrong_address_warning: "Attention : Si l'adresse réelle diffère de celle saisie (ex. numéro erroné changeant la zone), le livreur pourra demander un supplément.",
    // MARKETING
    marketing_btn: "Offres & Nouveautés",
    whats_new: "Quoi de neuf",
    marketing_offer: "Offre",
    marketing_offers: "Offres",
    marketing_news: "Nouveauté",
    no_variants_title: "Sans Variantes",
    no_variants_desc: "Vous avez choisi d'ajouter le produit sans sélectionner de variantes ou de suppléments. Êtes-vous sûr de vouloir continuer?",
    marketing_special_offer: "Offre Spéciale",
    marketing_featured_products: "Produits en Vedette",
    marketing_get_discount: "Obtenir Code Promo",
    marketing_order_now: "Commander",
    marketing_discount_applied: "La remise ({code}) sera appliquée au paiement. Valable une fois et expire dans 1 heure.",
    marketing_add_cart: "Ajouter au Panier",
    // EXTENDED MISSING STRINGS
    my_orders: "Mes Commandes",
    my_orders_desc: "Historique de vos commandes récentes dans ce magasin.",
    my_orders_loading: "Chargement des commandes...",
    my_orders_empty: "Aucune commande récente trouvée sur cet appareil.",
    order_num: "Commande #{id}",
    reorder: "Commander à nouveau",
    edit_order_time_limit: "Modifier Commande (Sous 3 min)",
    reorder_modal_title: "Choisir le Mode",
    reorder_modal_desc: "Comment souhaitez-vous recevoir votre commande ?",
    order_status_completed: "Terminé",
    order_status_cancelled: "Annulé",
    order_status_delivering: "En Livraison",
    order_status_preparing: "En Préparation",
    context_delivery: "Livraison",
    context_takeaway: "À Emporter",
    context_dinein: "Sur Place",
    go_to_cart: "Voir le Panier",
    cart_subtotal: "Sous-total",
    cart_delivery_fee: "Livraison",
    surge_fee: "Majoration Horaires / Fériés",
    takeaway_fee: "Supplément À Emporter",
    small_order_fee: "Supplément Commande Min",
    app_discount_label: "Remise Application",
    promo_quantity_discount_label: "Remise Quantité Promo",
    items_count: "({count} art.)",
    points_earned_badge: "+{points} Points",
    update_order_btn: "Mettre à jour la commande",
    free_delivery_super_reward: "Livraison Gratuite (Super Récompense)",
    mandatory_choice_alert: "⚠️ CHOIX OBLIGATOIRE\n\nVous devez sélectionner au moins {quantity} {category}.\nManquant : {missing}.",
    missing_free_title: "Options Gratuites Disponibles",
    missing_free_desc: "Cet article comprend des options gratuites non sélectionnées ({categories}). Que souhaitez-vous ajouter, ou continuer sans ?",
    name_modal_title: "Comment vous appelez-vous ?",
    name_modal_desc: "Entrez votre nom pour la commande.",
    name_modal_placeholder: "Votre nom...",
    intercom_modal_title: "Détails Livraison",
    intercom_modal_desc: "Entrez nom sur l'interphone, escalier ou étage.",
    intercom_modal_placeholder: "Ex. Interphone Dupont, 2e étage...",
    phone_modal_title_mandatory: "Numéro de Téléphone",
    phone_modal_title_optional: "Numéro de Portable (Conseillé)",
    phone_modal_desc_mandatory: "Requis pour la livraison ou le paiement en ligne.",
    phone_modal_desc_optional: "Si ignoré, vous ne recevrez pas l'avis de commande prête et perdrez vos points fidélité !",
    phone_modal_confirm_btn: "Confirmer le Numéro",
    phone_modal_skip_btn: "Continuer sans numéro (Perdre les points)",
    birthday_modal_title: "Quand est votre anniversaire ?",
    birthday_modal_desc: "Indiquez le jour et le mois pour recevoir un cadeau !",
    birthday_modal_gdpr: "(Conformité RGPD : nous ne collectons pas l'année)",
    birthday_modal_skip_btn: "Ignorer",
    privacy_modal_title: "Dernière étape !",
    privacy_modal_desc: "Veuillez accepter la politique de confidentialité pour continuer.",
    privacy_checkbox_text: "J'ai lu et j'accepte la",
    privacy_checkbox_mandatory: "(Obligatoire)",
    privacy_marketing_text: "Recevoir des promotions et remises exclusives ? (Optionnel)",
    privacy_confirm_btn: "Confirmer et Commander",
    privacy_error_alert: "Vous devez accepter la politique de confidentialité pour continuer.",
    payment_method_title: "Moyen de Paiement",
    payment_method_desc: "Comment préférez-vous payer ?",
    payment_cash: "Espèces",
    payment_cash_delivery: "Espèces à la livraison",
    payment_cash_pickup: "Payer au retrait",
    payment_pos_delivery: "CB (À la livraison)",
    payment_pos_store: "CB / Caisse",
    payment_pos_link: "CB / Lien de Paiement",
    payment_disabled_badge: "Désactivé"
  },
  es: {
    no_rider_found: "Ningún Rider aceptó el pedido en 30 minutos. Puedes volver a intentar enviar la solicitud o gestionarlo internamente.",
    status_open: "Abierto Ahora",
    status_closed: "Cerrado Ahora",
    closed_extra: "Cierre Especial",
    loading: "Cargando...",
    hours: "Horarios",
    about: "Nosotros",
    contact: "Contáctanos",
    store_location: "Nuestra Ubicación",
    events: "Eventos",
    dine_in: "Comer Aquí",
    dine_in_desc: "Has elegido comer en la mesa.",
    dine_in_desc_retail: "Servicio o consulta en el sitio.",
    take_away: "Para Llevar",
    take_away_desc: "Vienes a RECOGER tu pedido.",
    take_away_desc_retail: "Reserva y recoge en tienda.",
    delivery: "Domicilio",
    delivery_desc: "Un repartidor te llevará el pedido a casa.",
    delivery_desc_retail: "Envío o entrega a domicilio.",
    not_available: "No Disponible",
    suspended: "SUSPENDIDO",
    temp_unavailable: "TEMPORALMENTE NO DISPONIBLE",
    closed_msg: "Estamos Cerrados",
    closed_desc: "El local está cerrado actualmente.",
    browse_menu: "Ver Menú",
    browse_catalog: "Ver Catálogo",
    choose_menu_title: "Elige tu menú", // NEW
    choose_catalog_title: "Nuestro Catálogo", // NEW
    address_title: "¿Dónde entregamos?",
    address_title_retail: "¿Dirección de envío?",
    address_step1: "Paso 1: Calle",
    address_step2: "Paso 2: Ciudad",
    address_step3: "Paso 3: Número",
    next: "Siguiente",
    confirm_address: "Confirmar Dirección",
    verifying: "Verificando...",
    address_confirmed: "¡Dirección Confirmada!",
    delivery_cost: "Costo de Envío",
    shipping_cost: "Gastos de Envío",
    min_order: "Pedido Mínimo",
    go_to_menu: "Ir al Menú",
    go_to_catalog: "Ir al Catálogo",
    out_of_zone: "Fuera de Zona",
    out_of_zone_desc: "La dirección parece estar fuera de nuestra zona de servicio.",
    close: "Cerrar",
    confirm: "Confirmar",
    cancel: "Cancelar",
    wait_time: "Espera estimada",
    warning: "Atención",
    warning_takeaway: "NO es entrega a domicilio.",
    supplement: "Suplemento",
    send_msg: "Enviar Mensaje",
    write_us: "Escríbenos",
    your_name: "Tu Nombre",
    your_phone: "Teléfono (para respuesta)",
    order_id_opt: "ID Pedido (Opcional)",
    msg_placeholder: "Escribe tu mensaje aquí...",
    msg_warn: "Importante: No pedimos registro. ¡Si no pones el número, no podemos responder!",
    kiosk_mode: "Modo Quiosco",
    confirm_removal: "Confirmar eliminación",
    confirm_removal_message: "¿Estás seguro de que quieres eliminar {item}?",
    cart_title: "Carrito",
    cart_empty: "Tu carrito está vacío",
    start_ordering: "Empezar a pedir",
    promo_code: "Código Promocional",
    apply: "Aplicar",
    coupon_applied: "¡Cupón Aplicado!",
    shipping: "Envío",
    free: "Gratis",
    total_order: "Total Pedido",
    proceed: "Proceder",
    who_orders: "¿Quién pide?",
    table_number: "Número de Mesa",
    payment_method: "Método de pago",
    kitchen_notes: "Notas para la cocina",
    kitchen_notes_placeholder: "Ej. Sin perejil, bien hecho...",
    send_order: "Enviar Pedido",
    add: "Añadir",
    update: "Actualizar",
    total: "Total",
    how_to_serve: "¿Cómo servir?",
    serve_desc: "Elige cómo prefieres recibir este artículo.",
    plate: "En Plato",
    disposable: "Envase Desechable",
    best_sellers: "Más Vendidos y Recomendados",
    quick_add: "Añadir Rápido",
    order_again: "Pedir de nuevo",
    search_products: "Buscar productos...",
    search_results: "Resultados Búsqueda",
    no_results: "No se encontraron productos.",
    discover: "Descubrir",
    scroll_for_ingredients: "Desplázate para ingredientes",
    max_ingredients_limit: "¡Máx {count} variantes!",
    combination_applied: "¡Combinación aplicada!",
    order_updated: "¡Pedido actualizado!",
    item_added: "¡{item} añadido!",
    added_label: "Añadido: {item}",
    // RECEIPT
    receipt_copy: "Copia Cliente",
    receipt_payment: "PAGO",
    receipt_table: "MESA",
    receipt_takeaway: "PARA LLEVAR",
    receipt_delivery: "DOMICILIO",
    receipt_notes: "Notas",
    without: "SIN",
    // LOYALTY & BANNERS
    loyalty_title: "¡Descuento de {value}!",
    loyalty_reward_badge: "PREMIO FIDELIDAD", // DEFAULT TITLE
    loyalty_desc: "¡Gana puntos con cada pedido!", // DEFAULT DESC
    loyalty_card_info: "Tu número es tu tarjeta",
    super_reward_active: "¡{title} Activo!",
    super_reward_days_left: "Envíos gratis activos por {days} días más.",
    expires_on: "Caduca el",
    goal: "Objetivo",
    points_progress: "Puntos",
    points_missing: "¡Solo te faltan {points} puntos para desbloquear el premio!",
    goal_reached: "¡Objetivo Alcanzado! Ve al carrito para activarlo.",
    promo_code_label: "CÓDIGO",
    retail_pickup: "Recogida en Tienda",
    retail_delivery: "Envío / Entrega",
    loyalty_enter_number: "¡Introduce tu número para ganar puntos!",
    super_reward_default: "Súper Premio",
    // LOYALTY CHECK BALANCE
    check_points_btn: "Ver Saldo",
    check_points_modal_title: "Ingresa tu número",
    check_points_modal_desc: "Ingresa el móvil usado en pedidos anteriores para recuperar el saldo de puntos.",
    check_points_verify: "Verificar Puntos",
    check_points_verifying: "Verificando...",
    check_points_error_invalid: "Número no válido",
    check_points_error_not_found: "Número no encontrado. ¡Haz tu primer pedido para activar la tarjeta!",
    // NEW LOYALTY CART PROMPTS
    loyalty_prompt_title: "¡No pierdas los puntos! 🎁",
    loyalty_prompt_desc: "Ingresa tu número para acumular puntos y obtener <strong>recompensas exclusivas</strong>.",
    loyalty_your_phone_placeholder: "Tu móvil",
    loyalty_points_balance: "¡Tienes {points} Puntos!",
    loyalty_super_reward_btn: "Activar Súper Premio",
    // MISSING LOYALTY KEYS
    free_product: "Producto Gratis",
    added_to_cart: "Añadido al carrito",
    loyalty_discount: "Descuento Fidelidad",
    points_redeemed: "Puntos Usados",
    points_earned: "Puntos Ganados",
    loyalty_balance: "Saldo Puntos",
    // DYNAMIC RULE TEXTS
    loyalty_rule_spend: "Cada {amount}€ = 1 Punto.",
    loyalty_rule_order: "{amount} Puntos por pedido.",
    loyalty_claim_reward: "¡Consigue {amount} puntos para un premio!",
    // ADDRESS WARNING
    wrong_address_warning: "Advertencia: Si la dirección real difiere de la introducida (ej. número erróneo que cambia la zona), el repartidor puede solicitar un suplemento.",
    // MARKETING
    marketing_btn: "Ofertas y Novedades",
    whats_new: "Qué hay de nuevo",
    marketing_offer: "Oferta",
    marketing_offers: "Ofertas",
    marketing_news: "Novedad",
    no_variants_title: "Sin Variantes",
    no_variants_desc: "Has elegido añadir el producto sin seleccionar ninguna variante o extra. ¿Estás seguro de que quieres continuar?",
    marketing_special_offer: "Oferta Especial",
    marketing_featured_products: "Productos Destacados",
    marketing_get_discount: "Obtener Código de Descuento",
    marketing_order_now: "Pedir Ahora",
    marketing_discount_applied: "El descuento ({code}) se aplicará al pagar. Es de un solo uso y caduca en 1 hora.",
    marketing_add_cart: "Añadir al Carrito",
    // EXTENDED MISSING STRINGS
    my_orders: "Mis Pedidos",
    my_orders_desc: "Historial de tus pedidos recientes en esta tienda.",
    my_orders_loading: "Cargando pedidos...",
    my_orders_empty: "No se encontraron pedidos recientes en este dispositivo.",
    order_num: "Pedido #{id}",
    reorder: "Pedir de nuevo",
    edit_order_time_limit: "Modificar Pedido (En 3 min)",
    reorder_modal_title: "Elegir Modalidad",
    reorder_modal_desc: "¿Cómo deseas recibir tu pedido?",
    order_status_completed: "Completado",
    order_status_cancelled: "Cancelado",
    order_status_delivering: "En Reparto",
    order_status_preparing: "En Cocina",
    context_delivery: "A Domicilio",
    context_takeaway: "Para Llevar",
    context_dinein: "En Mesa",
    go_to_cart: "Ir al Carrito",
    cart_subtotal: "Subtotal",
    cart_delivery_fee: "Envío",
    surge_fee: "Suplemento Horario / Festivo",
    takeaway_fee: "Suplemento Para Llevar",
    small_order_fee: "Suplemento Pedido Mínimo",
    app_discount_label: "Descuento App",
    promo_quantity_discount_label: "Descuento Cantidad Promo",
    items_count: "({count} art.)",
    points_earned_badge: "+{points} Puntos",
    update_order_btn: "Actualizar Pedido",
    free_delivery_super_reward: "Envío Gratis (Súper Premio)",
    mandatory_choice_alert: "⚠️ ELECCIÓN OBLIGATORIA\n\nDebes seleccionar al menos {quantity} {category}.\nTe faltan: {missing}.",
    missing_free_title: "Opciones Gratis Disponibles",
    missing_free_desc: "Este producto incluye opciones gratuitas que no has seleccionado ({categories}). ¿Cuál prefieres añadir, o continuar sin ellas?",
    name_modal_title: "¿Cómo te llamas?",
    name_modal_desc: "Introduce tu nombre para el pedido.",
    name_modal_placeholder: "Tu nombre...",
    intercom_modal_title: "Detalles de Entrega",
    intercom_modal_desc: "Introduce nombre en portero, escalera o piso.",
    intercom_modal_placeholder: "Ej. Esc. B, Piso 3...",
    phone_modal_title_mandatory: "Número de Teléfono",
    phone_modal_title_optional: "Número Móvil (Recomendado)",
    phone_modal_desc_mandatory: "Requerido para la entrega o enviarte el enlace de pago.",
    phone_modal_desc_optional: "Si lo omites, no recibirás el aviso de pedido listo y perderás los puntos de fidelidad.",
    phone_modal_confirm_btn: "Confirmar Teléfono",
    phone_modal_skip_btn: "Continuar sin teléfono (Perder puntos)",
    birthday_modal_title: "¿Cuándo es tu cumpleaños?",
    birthday_modal_desc: "¡Introduce día y mes para recibir un regalo!",
    birthday_modal_gdpr: "(Por GDPR no recopilamos el año de nacimiento)",
    birthday_modal_skip_btn: "Omitir",
    privacy_modal_title: "¡Último paso!",
    privacy_modal_desc: "Para continuar debes aceptar la política de privacidad.",
    privacy_checkbox_text: "He leído y acepto la",
    privacy_checkbox_mandatory: "(Obligatorio)",
    privacy_marketing_text: "¿Recibir promociones y descuentos exclusivos? (Opcional)",
    privacy_confirm_btn: "Confirmar y Enviar Pedido",
    privacy_error_alert: "Debes aceptar la Política de Privacidad para continuar.",
    payment_method_title: "Método de Pago",
    payment_method_desc: "¿Cómo prefieres pagar?",
    payment_cash: "Efectivo",
    payment_cash_delivery: "Contra reembolso",
    payment_cash_pickup: "Pagar al recoger",
    payment_pos_delivery: "Datáfono (En entrega)",
    payment_pos_store: "Datáfono / Caja",
    payment_pos_link: "Datáfono / Enlace de Pago",
    payment_disabled_badge: "Desactivado"
  },
  de: {
    no_rider_found: "Kein Rider hat die Bestellung innerhalb von 30 Minuten angenommen. Sie können die Anfrage erneut senden oder intern bearbeiten.",
    status_open: "Jetzt Geöffnet",
    status_closed: "Geschlossen",
    closed_extra: "Sondergeschlossen",
    loading: "Laden...",
    hours: "Öffnungszeiten",
    about: "Über Uns",
    contact: "Kontakt",
    store_location: "Unser Standort",
    events: "Veranstaltungen",
    dine_in: "Hier Essen",
    dine_in_desc: "Sie haben gewählt, am Tisch zu essen.",
    dine_in_desc_retail: "Service oder Beratung vor Ort.",
    take_away: "Zum Mitnehmen",
    take_away_desc: "Sie holen die Bestellung SELBST ab.",
    take_away_desc_retail: "Reservieren und abholen.",
    delivery: "Lieferung",
    delivery_desc: "Ein Fahrer bringt Ihre Bestellung nach Hause.",
    delivery_desc_retail: "Versand oder Lieferung.",
    not_available: "Nicht Verfügbar",
    suspended: "AUSGESETZT",
    temp_unavailable: "VORÜBERGEHEND NICHT VERFÜGBAR",
    closed_msg: "Wir sind Geschlossen",
    closed_desc: "Das Geschäft ist derzeit geschlossen.",
    browse_menu: "Menü Ansehen",
    browse_catalog: "Katalog Ansehen",
    choose_menu_title: "Wähle dein Menü", // NEW
    choose_catalog_title: "Unser Katalog", // NEW
    address_title: "Wohin liefern?",
    address_title_retail: "Lieferadresse?",
    address_step1: "Schritt 1: Straße",
    address_step2: "Schritt 2: Stadt",
    address_step3: "Schritt 3: Hausnummer",
    next: "Weiter",
    confirm_address: "Adresse Bestätigen",
    verifying: "Überprüfung...",
    address_confirmed: "Adresse Bestätigt!",
    delivery_cost: "Lieferkosten",
    shipping_cost: "Versandkosten",
    min_order: "Mindestbestellwert",
    go_to_menu: "Zum Menü",
    go_to_catalog: "Zum Katalog",
    out_of_zone: "Außerhalb der Zone",
    out_of_zone_desc: "Die Adresse scheint außerhalb unseres Liefergebiets zu liegen.",
    close: "Schließen",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    wait_time: "Wartezeit",
    warning: "Achtung",
    warning_takeaway: "Dies ist KEINE Lieferung nach Hause.",
    supplement: "Aufpreis",
    send_msg: "Nachricht Senden",
    write_us: "Schreiben Sie uns",
    your_name: "Ihr Name",
    your_phone: "Telefon (für Antwort)",
    order_id_opt: "Bestell-ID (Optional)",
    msg_placeholder: "Schreiben Sie hier Ihre Nachricht...",
    msg_warn: "Wichtig: Keine Registrierung. Ohne Nummer können wir nicht antworten!",
    kiosk_mode: "Kiosk-Modus",
    confirm_removal: "Entfernen bestätigen",
    confirm_removal_message: "Möchten Sie {item} wirklich entfernen?",
    cart_title: "Warenkorb",
    cart_empty: "Ihr Warenkorb ist leer",
    start_ordering: "Bestellung starten",
    promo_code: "Gutscheincode",
    apply: "Anwenden",
    coupon_applied: "Gutschein angewendet!",
    shipping: "Versand",
    free: "Gratis",
    total_order: "Gesamtbetrag",
    proceed: "Fortfahren",
    who_orders: "Wer bestellt?",
    table_number: "Tischnummer",
    payment_method: "Zahlungsmethode",
    kitchen_notes: "Küchennotizen",
    kitchen_notes_placeholder: "Z.B. Keine Petersilie, gut durch...",
    send_order: "Bestellung Senden",
    add: "Hinzufügen",
    update: "Aktualisieren",
    total: "Gesamt",
    how_to_serve: "Wie servieren?",
    serve_desc: "Wählen Sie, wie Sie diesen Artikel erhalten möchten.",
    plate: "Auf Teller",
    disposable: "Einwegverpackung",
    best_sellers: "Bestseller & Empfohlen",
    quick_add: "Schnell hinzufügen",
    order_again: "Nochmal bestellen",
    search_products: "Produkte suchen...",
    search_results: "Suchergebnisse",
    no_results: "Keine Produkte gefunden.",
    discover: "Entdecken",
    scroll_for_ingredients: "Scrollen für Zutaten",
    max_ingredients_limit: "Max {count} Varianten!",
    combination_applied: "Kombination angewendet!",
    order_updated: "Bestellung aktualisiert!",
    item_added: "{item} hinzugefügt!",
    added_label: "Hinzugefügt: {item}",
    // RECEIPT
    receipt_copy: "Kundenkopie",
    receipt_payment: "ZAHLUNG",
    receipt_table: "TISCH",
    receipt_takeaway: "MITNEHMEN",
    receipt_delivery: "LIEFERUNG",
    receipt_notes: "Notizen",
    without: "OHNE",
    // LOYALTY & BANNERS
    loyalty_title: "Rabatt von {value}!",
    loyalty_reward_badge: "TREUEPRÄMIE", // DEFAULT TITLE
    loyalty_desc: "Sammeln Sie Punkte bei jeder Bestellung!", // DEFAULT DESC
    loyalty_card_info: "Ihre Nummer ist Ihre Karte",
    super_reward_active: "{title} Aktiv!",
    super_reward_days_left: "Kostenlose Lieferung noch für {days} Tage aktiv.",
    expires_on: "Läuft ab am",
    goal: "Ziel",
    points_progress: "Punkte",
    points_missing: "Sie benötigen nur noch {points} Punkte, um die Belohnung freizuschalten!",
    goal_reached: "Ziel erreicht! Gehen Sie zum Warenkorb, um es zu aktivieren.",
    promo_code_label: "CODE",
    retail_pickup: "Abholung im Geschäft",
    retail_delivery: "Versand / Lieferung",
    loyalty_enter_number: "Geben Sie Ihre Nummer ein, um Punkte zu sammeln!",
    super_reward_default: "Super-Belohnung",
    // LOYALTY CHECK BALANCE
    check_points_btn: "Kontostand prüfen",
    check_points_modal_title: "Nummer eingeben",
    check_points_modal_desc: "Geben Sie die Handynummer ein, die für frühere Bestellungen verwendet wurde, um den Punktestand abzurufen.",
    check_points_verify: "Punkte prüfen",
    check_points_verifying: "Überprüfung...",
    check_points_error_invalid: "Ungültige Nummer",
    check_points_error_not_found: "Nummer nicht gefunden. Bestellen Sie zum ersten Mal, um die Karte zu aktivieren!",
    // NEW LOYALTY CART PROMPTS
    loyalty_prompt_title: "Verpassen Sie keine Punkte! 🎁",
    loyalty_prompt_desc: "Geben Sie Ihre Nummer ein, um Punkte zu sammeln und <strong>exklusive Belohnungen</strong> zu erhalten.",
    loyalty_your_phone_placeholder: "Ihre Handynummer",
    loyalty_points_balance: "Sie haben {points} Punkte!",
    loyalty_super_reward_btn: "Super-Belohnung aktivieren",
    // MISSING LOYALTY KEYS
    free_product: "Gratisprodukt",
    added_to_cart: "In den Warenkorb",
    loyalty_discount: "Treuerabatt",
    points_redeemed: "Punkte Eingelöst",
    points_earned: "Punkte Verdient",
    loyalty_balance: "Punktestand",
    // DYNAMIC RULE TEXTS
    loyalty_rule_spend: "Jede {amount}€ = 1 Punkt.",
    loyalty_rule_order: "{amount} Punkte pro Bestellung.",
    loyalty_claim_reward: "Sammle {amount} Punkte für eine Belohnung!",
    // ADDRESS WARNING
    wrong_address_warning: "Warnung: Weicht die tatsächliche Adresse von der eingegebenen ab (z.B. falsche Hausnummer ändert Zone), kann der Fahrer einen Aufpreis verlangen.",
    // MARKETING
    marketing_btn: "Angebote & Neuigkeiten",
    whats_new: "Was gibt's Neues",
    marketing_offer: "Angebot",
    marketing_offers: "Angebote",
    marketing_news: "Neuheit",
    no_variants_title: "Keine Varianten",
    no_variants_desc: "Sie haben sich entschieden, das Produkt ohne Varianten oder Extras hinzuzufügen. Sind Sie sicher, dass Sie fortfahren möchten?",
    marketing_special_offer: "Sonderangebot",
    marketing_featured_products: "Ausgewählte Produkte",
    marketing_get_discount: "Rabattcode Erhalten",
    marketing_order_now: "Jetzt Bestellen",
    marketing_discount_applied: "Der Rabatt ({code}) wird an der Kasse abgezogen. Er ist einmalig gültig und verfällt in 1 Stunde.",
    marketing_add_cart: "In den Warenkorb",
    // EXTENDED MISSING STRINGS
    my_orders: "Meine Bestellungen",
    my_orders_desc: "Verlauf Ihrer letzten Bestellungen in diesem Geschäft.",
    my_orders_loading: "Bestellungen werden geladen...",
    my_orders_empty: "Keine aktuellen Bestellungen auf diesem Gerät gefunden.",
    order_num: "Bestellung #{id}",
    reorder: "Erneut bestellen",
    edit_order_time_limit: "Bestellung bearbeiten (Innerhalb 3 Min.)",
    reorder_modal_title: "Bestellart wählen",
    reorder_modal_desc: "Wie möchten Sie Ihre Bestellung erhalten?",
    order_status_completed: "Abgeschlossen",
    order_status_cancelled: "Storniert",
    order_status_delivering: "In Zustellung",
    order_status_preparing: "In Zubereitung",
    context_delivery: "Lieferung",
    context_takeaway: "Mitnehmen",
    context_dinein: "Tisch",
    go_to_cart: "Zum Warenkorb",
    cart_subtotal: "Zwischensumme",
    cart_delivery_fee: "Lieferung",
    surge_fee: "Feiertags- / Stoßzeitaufschlag",
    takeaway_fee: "Mitnahme-Aufschlag",
    small_order_fee: "Mindermengenzuschlag",
    app_discount_label: "App-Rabatt",
    promo_quantity_discount_label: "Mengenrabatt-Aktion",
    items_count: "({count} Art.)",
    points_earned_badge: "+{points} Punkte",
    update_order_btn: "Bestellung Aktualisieren",
    free_delivery_super_reward: "Kostenlose Lieferung (Super-Belohnung)",
    mandatory_choice_alert: "⚠️ PFLICHTAUSWAHL\n\nSie müssen mindestens {quantity} {category} wählen.\nEs fehlen: {missing}.",
    missing_free_title: "Gratis-Optionen Verfügbar",
    missing_free_desc: "Dieses Produkt enthält kostenlose Optionen, die Sie nicht ausgewählt haben ({categories}). Welche möchten Sie hinzufügen oder ohne fortfahren?",
    name_modal_title: "Wie heißen Sie?",
    name_modal_desc: "Geben Sie Ihren Namen für die Bestellung ein.",
    name_modal_placeholder: "Ihr Name...",
    intercom_modal_title: "Lieferdetails",
    intercom_modal_desc: "Geben Sie Klingelschild, Treppenhaus oder Etage an.",
    intercom_modal_placeholder: "Z.B. Klingel Müller, 2. OG...",
    phone_modal_title_mandatory: "Telefonnummer",
    phone_modal_title_optional: "Mobilnummer (Empfohlen)",
    phone_modal_desc_mandatory: "Erforderlich für Lieferung oder Zahlungslink.",
    phone_modal_desc_optional: "Wenn übersprungen, verpassen Sie die Fertigmeldung und Treuepunkte!",
    phone_modal_confirm_btn: "Nummer Bestätigen",
    phone_modal_skip_btn: "Ohne Nummer fortfahren (Keine Punkte)",
    birthday_modal_title: "Wann haben Sie Geburtstag?",
    birthday_modal_desc: "Geben Sie Tag und Monat ein, um ein Geschenk zu erhalten!",
    birthday_modal_gdpr: "(Aus Datenschutzgründen speichern wir kein Geburtsjahr)",
    birthday_modal_skip_btn: "Überspringen",
    privacy_modal_title: "Letzter Schritt!",
    privacy_modal_desc: "Bitte akzeptieren Sie die Datenschutzrichtlinie, um fortzufahren.",
    privacy_checkbox_text: "Ich habe die Datenschutzrichtlinie gelesen und akzeptiere die",
    privacy_checkbox_mandatory: "(Erforderlich)",
    privacy_marketing_text: "Exklusive Angebote und Rabatte erhalten? (Optional)",
    privacy_confirm_btn: "Bestätigen und Bestellen",
    privacy_error_alert: "Sie müssen die Datenschutzrichtlinie akzeptieren.",
    payment_method_title: "Zahlungsmethode",
    payment_method_desc: "Wie möchten Sie bezahlen?",
    payment_cash: "Bargeld",
    payment_cash_delivery: "Barzahlung bei Lieferung",
    payment_cash_pickup: "Zahlung bei Abholung",
    payment_pos_delivery: "Kartenzahlung (Bei Lieferung)",
    payment_pos_store: "Kartenzahlung / Kasse",
    payment_pos_link: "Kartenzahlung / Zahlungslink",
    payment_disabled_badge: "Deaktiviert"
  },
  pt: {
    no_rider_found: "Nenhum Rider aceitou o pedido em 30 minutos. Você pode tentar enviar o pedido novamente ou gerenciar internamente.",
    status_open: "Aberto agora",
    status_closed: "Fechado agora",
    closed_extra: "Fecho Extraordinário", 
    loading: "A carregar...",
    hours: "Horários",
    about: "Sobre nós",
    contact: "Contactos",
    store_location: "Localização",
    events: "Eventos",
    dine_in: "Comer Aqui",
    dine_in_desc: "Você escolheu consumir na mesa.",
    dine_in_desc_retail: "Serviço no local.",
    take_away: "Take-away",
    take_away_desc: "Você vai RECOLHER o seu pedido.",
    take_away_desc_retail: "Reserve e recolha.",
    delivery: "Entrega em Domicílio",
    delivery_desc: "Um estafeta entregará o pedido.",
    delivery_desc_retail: "Envio para a morada.",
    not_available: "Indisponível",
    suspended: "SUSPENSO",
    temp_unavailable: "INDISPONÍVEL", 
    closed_msg: "Estamos Fechados",
    closed_desc: "O estabelecimento está fechado.",
    browse_menu: "Ver Menu",
    browse_catalog: "Ver Catálogo",
    choose_menu_title: "Escolha o menu",
    choose_catalog_title: "O nosso Catálogo",
    address_title: "Onde entregamos?",
    address_title_retail: "Morada de envio?",
    address_step1: "Passo 1: Rua",
    address_step2: "Passo 2: Cidade",
    address_step3: "Passo 3: Número",
    next: "Seguinte",
    confirm_address: "Confirmar",
    verifying: "A verificar...",
    address_confirmed: "Confirmado!",
    delivery_cost: "Custo de Entrega",
    shipping_cost: "Custo de Envio",
    min_order: "Pedido Mínimo",
    go_to_menu: "Menu",
    go_to_catalog: "Catálogo",
    out_of_zone: "Fora de Zona",
    out_of_zone_desc: "Fora da área de serviço.",
    close: "Fechar",
    confirm: "Confirmar",
    cancel: "Cancelar",
    wait_time: "Espera estimada",
    warning: "Aviso",
    warning_takeaway: "NÃO é entrega ao domicílio.",
    supplement: "Suplemento",
    send_msg: "Enviar Mensagem",
    write_us: "Escreva-nos",
    your_name: "O seu nome",
    your_phone: "Telemóvel",
    order_id_opt: "Nº Pedido (Opcional)",
    msg_placeholder: "Mensagem...",
    msg_warn: "Precisamos do nº para responder!",
    kiosk_mode: "Quiosque",
    confirm_removal: "Remover",
    confirm_removal_message: "Remover {item}?",
    cart_title: "Carrinho",
    cart_empty: "Vazio",
    start_ordering: "Começar a pedir",
    promo_code: "Código Promocional",
    apply: "Aplicar",
    coupon_applied: "Cupão aplicado!",
    shipping: "Envio",
    free: "Grátis",
    total_order: "Total do Pedido",
    proceed: "Avançar",
    who_orders: "Nome",
    table_number: "Mesa",
    payment_method: "Pagamento",
    kitchen_notes: "Notas",
    kitchen_notes_placeholder: "Escreva aqui...",
    send_order: "Enviar Pedido",
    add: "Adicionar",
    update: "Atualizar",
    total: "Total",
    how_to_serve: "Servir?",
    serve_desc: "Escolha como prefere.",
    plate: "No Prato",
    disposable: "Descartável",
    best_sellers: "Mais Vendidos",
    quick_add: "Adicionar Rapidamente",
    order_again: "Pedir Novamente",
    search_products: "Pesquisar...",
    search_results: "Resultados",
    no_results: "Nenhum resultado.",
    discover: "Descubra",
    scroll_for_ingredients: "Mais ingredientes...",
    max_ingredients_limit: "Máximo {count}!",
    combination_applied: "Aplicada!",
    order_updated: "Atualizado!",
    item_added: "{item} adicionado!",
    added_label: "Lá fora: {item}",
    receipt_copy: "Cópia",
    receipt_payment: "PAGAMENTO",
    receipt_table: "MESA",
    receipt_takeaway: "TAKE-AWAY",
    receipt_delivery: "ENTREGA",
    receipt_notes: "Notas",
    without: "SEM",
    loyalty_title: "Desconto {value}!",
    loyalty_reward_badge: "PRÉMIO",
    loyalty_desc: "Ganhe pontos!",
    loyalty_card_info: "Cartão: o seu número",
    super_reward_active: "{title} Ativo!",
    super_reward_days_left: "Mais {days} dias.",
    expires_on: "Expira",
    goal: "Objetivo",
    points_progress: "Pontos",
    points_missing: "Precisa de {points} pontos!",
    goal_reached: "Alcançado!",
    promo_code_label: "CÓDIGO",
    retail_pickup: "Recolha",
    retail_delivery: "Entrega",
    loyalty_enter_number: "Ganhe pontos!",
    super_reward_default: "Super Prémio",
    check_points_btn: "Saldo",
    check_points_modal_title: "Número",
    check_points_modal_desc: "Insira contacto.",
    check_points_verify: "Verificar",
    check_points_verifying: "Aguardar...",
    check_points_error_invalid: "Número inválido",
    check_points_error_not_found: "Não encontrado.",
    loyalty_prompt_title: "Ganhe prémios!",
    loyalty_prompt_desc: "Acumule pontos.",
    loyalty_your_phone_placeholder: "O seu contacto",
    loyalty_points_balance: "Tem {points} Pontos!",
    loyalty_super_reward_btn: "Ativar Prêmio",
    free_product: "Produto Grátis",
    added_to_cart: "No carrinho",
    loyalty_discount: "Desconto Fidelidade",
    points_redeemed: "Pontos Usados",
    points_earned: "Pontos Ganhos",
    loyalty_balance: "Saldo",
    loyalty_rule_spend: "Cada {amount}€=1pt.",
    loyalty_rule_order: "{amount}pts por pedido.",
    loyalty_claim_reward: "Ganhe prémio com {amount}pts!",
    wrong_address_warning: "Aviso: morada divergente.",
    marketing_btn: "Ofertas",
    whats_new: "Novidades",
    marketing_offer: "Oferta",
    marketing_offers: "Ofertas",
    marketing_news: "Novidade",
    no_variants_title: "Sem Variantes",
    no_variants_desc: "Sem seleção de variante?",
    marketing_special_offer: "Oferta Especial",
    marketing_featured_products: "Em Destaque",
    marketing_get_discount: "Obter Desconto",
    marketing_order_now: "Pedir",
    marketing_discount_applied: "Desconto aplicado ({code}).",
    marketing_add_cart: "Comprar",
    // EXTENDED MISSING STRINGS
    my_orders: "Os Meus Pedidos",
    my_orders_desc: "Histórico dos seus pedidos recentes nesta loja.",
    my_orders_loading: "A carregar pedidos...",
    my_orders_empty: "Nenhum pedido recente encontrado neste dispositivo.",
    order_num: "Pedido #{id}",
    reorder: "Pedir Novamente",
    edit_order_time_limit: "Alterar Pedido (Em 3 min)",
    reorder_modal_title: "Escolha o Modo",
    reorder_modal_desc: "Como prefere receber o seu pedido?",
    order_status_completed: "Concluído",
    order_status_cancelled: "Cancelado",
    order_status_delivering: "Em Entrega",
    order_status_preparing: "Na Cozinha",
    context_delivery: "Domicílio",
    context_takeaway: "Take-away",
    context_dinein: "Mesa",
    go_to_cart: "Ir para o Carrinho",
    cart_subtotal: "Subtotal",
    cart_delivery_fee: "Entrega",
    surge_fee: "Taxa Horário / Feriado",
    takeaway_fee: "Taxa Take-away",
    small_order_fee: "Taxa Pedido Mínimo",
    app_discount_label: "Desconto App",
    promo_quantity_discount_label: "Desconto Quantidade Promo",
    items_count: "({count} itens)",
    points_earned_badge: "+{points} Pontos",
    update_order_btn: "Atualizar Pedido",
    free_delivery_super_reward: "Entrega Grátis (Super Prémio)",
    mandatory_choice_alert: "⚠️ ESCOLHA OBRIGATÓRIA\n\nDeve selecionar pelo menos {quantity} {category}.\nFaltam: {missing}.",
    missing_free_title: "Opções Grátis Disponíveis",
    missing_free_desc: "Este produto inclui opções gratuitas não selecionadas ({categories}). Deseja adicionar ou continuar sem?",
    name_modal_title: "Como se chama?",
    name_modal_desc: "Insira o seu nome para o pedido.",
    name_modal_placeholder: "O seu nome...",
    intercom_modal_title: "Detalhes da Entrega",
    intercom_modal_desc: "Insira nome no intercomunicador, escada ou piso.",
    intercom_modal_placeholder: "Ex. Bloco B, 2º Esq...",
    phone_modal_title_mandatory: "Número de Telemóvel",
    phone_modal_title_optional: "Contacto Móvel (Recomendado)",
    phone_modal_desc_mandatory: "Necessário para a entrega ou envio de link de pagamento.",
    phone_modal_desc_optional: "Se ignorar, não receberá o aviso de pronto e perderá os pontos de fidelidade!",
    phone_modal_confirm_btn: "Confirmar Telemóvel",
    phone_modal_skip_btn: "Continuar sem telemóvel (Sem pontos)",
    birthday_modal_title: "Quando faz anos?",
    birthday_modal_desc: "Indique o dia e mês para receber uma oferta!",
    birthday_modal_gdpr: "(Por privacidade RGPD não recolhemos o ano)",
    birthday_modal_skip_btn: "Ignorar",
    privacy_modal_title: "Último passo!",
    privacy_modal_desc: "Para prosseguir é necessário aceitar a política de privacidade.",
    privacy_checkbox_text: "Li e aceito a",
    privacy_checkbox_mandatory: "(Obrigatório)",
    privacy_marketing_text: "Deseja receber promoções e descontos exclusivos? (Opcional)",
    privacy_confirm_btn: "Confirmar e Enviar Pedido",
    privacy_error_alert: "Tem de aceitar a Política de Privacidade para continuar.",
    payment_method_title: "Método de Pagamento",
    payment_method_desc: "Como prefere pagar?",
    payment_cash: "Dinheiro",
    payment_cash_delivery: "Cobrança na entrega",
    payment_cash_pickup: "Pagar no levantamento",
    payment_pos_delivery: "TPA (Na entrega)",
    payment_pos_store: "TPA / Caixa",
    payment_pos_link: "TPA / Link de Pagamento",
    payment_disabled_badge: "Desativado"
  },
  ru: {
    no_rider_found: "Райдер не принял заказ в течение 30 минут. Вы можете повторить попытку или обработать заказ самостоятельно.",
    status_open: "Открыто сейчас",
    status_closed: "Закрыто сейчас",
    closed_extra: "Специальное закрытие", 
    loading: "Загрузка...",
    hours: "Часы работы",
    about: "О нас",
    contact: "Контакты",
    store_location: "Локация",
    events: "События",
    dine_in: "В заведении",
    dine_in_desc: "Заказ за столиком.",
    dine_in_desc_retail: "Обслуживание на месте.",
    take_away: "Навынос",
    take_away_desc: "Заказ с собой.",
    take_away_desc_retail: "Забронировать и забрать.",
    delivery: "Доставка",
    delivery_desc: "Мы доставим ваш заказ.",
    delivery_desc_retail: "Доставка на адрес.",
    not_available: "Недоступно",
    suspended: "ПРИОСТАНОВЛЕНО",
    temp_unavailable: "ВРЕМЕННО НЕДОСТУПНО", 
    closed_msg: "Мы закрыты",
    closed_desc: "Заведение сейчас закрыто.",
    browse_menu: "Посмотреть меню",
    browse_catalog: "Посмотреть каталог",
    choose_menu_title: "Выберите меню",
    choose_catalog_title: "Наш каталог",
    address_title: "Куда доставить?",
    address_title_retail: "Адрес доставки?",
    address_step1: "Шаг 1: Улица",
    address_step2: "Шаг 2: Город",
    address_step3: "Шаг 3: Номер дома",
    next: "Далее",
    confirm_address: "Подтвердить адрес",
    verifying: "Проверка...",
    address_confirmed: "Успешно!",
    delivery_cost: "Стоимость",
    shipping_cost: "Доставка",
    min_order: "Мин. заказ",
    go_to_menu: "В меню",
    go_to_catalog: "В каталог",
    out_of_zone: "Вне зоны",
    out_of_zone_desc: "Адрес вне зоны обслуживания.",
    close: "Закрыть",
    confirm: "ОК",
    cancel: "Отмена",
    wait_time: "Ожидание",
    warning: "Внимание",
    warning_takeaway: "Это НЕ доставка.",
    supplement: "Доплата",
    send_msg: "Отправить сообщение",
    write_us: "Напишите нам",
    your_name: "Ваше имя",
    your_phone: "Телефон",
    order_id_opt: "ID заказа (Опционально)",
    msg_placeholder: "Сообщение...",
    msg_warn: "Нужен номер для ответа!",
    kiosk_mode: "Киоск",
    confirm_removal: "Подтвердить удаление",
    confirm_removal_message: "Удалить {item}?",
    cart_title: "Корзина",
    cart_empty: "Пусто",
    start_ordering: "Начать выбор",
    promo_code: "Промокод",
    apply: "Применить",
    coupon_applied: "Применен!",
    shipping: "Доставка",
    free: "Бесплатно",
    total_order: "Итого",
    proceed: "Продолжить",
    who_orders: "Имя клиента",
    table_number: "Стол",
    payment_method: "Оплата",
    kitchen_notes: "Примечания для кухни",
    kitchen_notes_placeholder: "Без лука...",
    send_order: "Отправить заказ",
    add: "Добавить",
    update: "Обновить",
    total: "Итого",
    how_to_serve: "Подача?",
    serve_desc: "Как вам подать?",
    plate: "На тарелке",
    disposable: "С собой",
    best_sellers: "Популярное",
    quick_add: "Быстрое добавление",
    order_again: "Повторить",
    search_products: "Поиск...",
    search_results: "Результаты",
    no_results: "Нет результатов.",
    discover: "Интересное",
    scroll_for_ingredients: "Листайте дальше",
    max_ingredients_limit: "Макс: {count}!",
    combination_applied: "Применено!",
    order_updated: "Обновлено!",
    item_added: "{item} добавлен!",
    added_label: "Добавлено: {item}",
    receipt_copy: "Копия",
    receipt_payment: "ОПЛАТА",
    receipt_table: "СТОЛ",
    receipt_takeaway: "НАВЫНОС",
    receipt_delivery: "ДОСТАВКА",
    receipt_notes: "Примечания",
    without: "БЕЗ",
    loyalty_title: "Скидка {value}!",
    loyalty_reward_badge: "НАГРАДА",
    loyalty_desc: "Зарабатывайте очки!",
    loyalty_card_info: "Ваш номер — ваша карта",
    super_reward_active: "{title} Активна!",
    super_reward_days_left: "Ещё {days} дней.",
    expires_on: "До",
    goal: "Цель",
    points_progress: "Очки",
    points_missing: "Нужно {points} очков!",
    goal_reached: "Достигнуто!",
    promo_code_label: "КОД",
    retail_pickup: "Самовывоз",
    retail_delivery: "Доставка",
    loyalty_enter_number: "Получить бонусы!",
    super_reward_default: "Супер Награда",
    check_points_btn: "Проверить баланс",
    check_points_modal_title: "Номер",
    check_points_modal_desc: "Введите номер.",
    check_points_verify: "Проверить",
    check_points_verifying: "Загрузка...",
    check_points_error_invalid: "Неверный номер",
    check_points_error_not_found: "Не найден.",
    loyalty_prompt_title: "Получайте награды!",
    loyalty_prompt_desc: "Накапливайте очки.",
    loyalty_your_phone_placeholder: "Ваш телефон",
    loyalty_points_balance: "У вас {points} очков!",
    loyalty_super_reward_btn: "Активировать",
    free_product: "Товар в подарок",
    added_to_cart: "В корзине",
    loyalty_discount: "Скидка",
    points_redeemed: "Потрачено очков",
    points_earned: "Получено очков",
    loyalty_balance: "Баланс",
    loyalty_rule_spend: "Каждые {amount}=1очко.",
    loyalty_rule_order: "{amount}оч. за заказ.",
    loyalty_claim_reward: "{amount} очк. = награда!",
    wrong_address_warning: "Внимание: неверный адрес.",
    marketing_btn: "Акции",
    whats_new: "Новости",
    marketing_offer: "Акция",
    marketing_offers: "Акции",
    marketing_news: "Новинка",
    no_variants_title: "Без вариантов",
    no_variants_desc: "Продолжить без добавок?",
    marketing_special_offer: "Специальное предложение",
    marketing_featured_products: "Рекомендуем",
    marketing_get_discount: "Получить скидку",
    marketing_order_now: "Заказать",
    marketing_discount_applied: "Скидка({code}) применена.",
    marketing_add_cart: "В корзину",
    // EXTENDED MISSING STRINGS
    my_orders: "Мои заказы",
    my_orders_desc: "История ваших недавних заказов в этом заведении.",
    my_orders_loading: "Загрузка заказов...",
    my_orders_empty: "На этом устройстве не найдено недавних заказов.",
    order_num: "Заказ #{id}",
    reorder: "Повторить заказ",
    edit_order_time_limit: "Изменить заказ (в течение 3 мин)",
    reorder_modal_title: "Выберите способ",
    reorder_modal_desc: "Как вы хотите получить свой заказ?",
    order_status_completed: "Выполнен",
    order_status_cancelled: "Отменен",
    order_status_delivering: "В пути",
    order_status_preparing: "Готовится",
    context_delivery: "Доставка",
    context_takeaway: "Навынос",
    context_dinein: "В заведении",
    go_to_cart: "Перейти в корзину",
    cart_subtotal: "Подытог",
    cart_delivery_fee: "Доставка",
    surge_fee: "Праздничная наценка",
    takeaway_fee: "Доплата за упаковку навынос",
    small_order_fee: "Доплата за мин. заказ",
    app_discount_label: "Скидка в приложении",
    promo_quantity_discount_label: "Скидка за количество",
    items_count: "({count} шт.)",
    points_earned_badge: "+{points} Бонусов",
    update_order_btn: "Обновить заказ",
    free_delivery_super_reward: "Бесплатная доставка (Супер награда)",
    mandatory_choice_alert: "⚠️ ОБЯЗАТЕЛЬНЫЙ ВЫБОР\n\nНеобходимо выбрать минимум {quantity} {category}.\nОсталось: {missing}.",
    missing_free_title: "Доступны бесплатные опции",
    missing_free_desc: "В этот товар входят бесплатные опции, которые вы не выбрали ({categories}). Хотите добавить или продолжить без них?",
    name_modal_title: "Как вас зовут?",
    name_modal_desc: "Укажите ваше имя для заказа.",
    name_modal_placeholder: "Ваше имя...",
    intercom_modal_title: "Детали доставки",
    intercom_modal_desc: "Укажите домофон, подъезд или этаж.",
    intercom_modal_placeholder: "Напр. Подъезд 2, кв. 45...",
    phone_modal_title_mandatory: "Номер телефона",
    phone_modal_title_optional: "Номер телефона (Рекомендуется)",
    phone_modal_desc_mandatory: "Требуется для доставки или отправки ссылки на оплату.",
    phone_modal_desc_optional: "Если пропустить, вы не получите уведомление о готовности и потеряете бонусы!",
    phone_modal_confirm_btn: "Подтвердить номер",
    phone_modal_skip_btn: "Продолжить без номера (Без бонусов)",
    birthday_modal_title: "Когда у вас день рождения?",
    birthday_modal_desc: "Укажите день и месяц, чтобы получить подарок!",
    birthday_modal_gdpr: "(В целях конфиденциальности мы не сохраняем год рождения)",
    birthday_modal_skip_btn: "Пропустить",
    privacy_modal_title: "Последний шаг!",
    privacy_modal_desc: "Пожалуйста, подтвердите согласие с политикой конфиденциальности.",
    privacy_checkbox_text: "Я принимаю",
    privacy_checkbox_mandatory: "(Обязательно)",
    privacy_marketing_text: "Получать скидки и персональные предложения? (Необязательно)",
    privacy_confirm_btn: "Подтвердить и отправить заказ",
    privacy_error_alert: "Необходимо принять политику конфиденциальности.",
    payment_method_title: "Способ оплаты",
    payment_method_desc: "Как вы хотите оплатить заказ?",
    payment_cash: "Наличные",
    payment_cash_delivery: "Наличными курьеру",
    payment_cash_pickup: "Оплата при получении",
    payment_pos_delivery: "Терминал при доставке",
    payment_pos_store: "Терминал / Касса",
    payment_pos_link: "Ссылка на оплату",
    payment_disabled_badge: "Недоступно"
  },
  nl: {
    no_rider_found: "Geen Rider heeft de bestelling binnen 30 minuten geaccepteerd. U kunt de aanvraag opnieuw verzenden of intern afhandelen.",
    status_open: "Nu geopend",
    status_closed: "Nu gesloten",
    closed_extra: "Extra gesloten", 
    loading: "Laden...",
    hours: "Openingstijden",
    about: "Over ons",
    contact: "Contact",
    store_location: "Winkel locatie",
    events: "Evenementen",
    dine_in: "Hier Eten",
    dine_in_desc: "Aan tafel consumeren.",
    dine_in_desc_retail: "Service op locatie.",
    take_away: "Afhalen",
    take_away_desc: "Bestelling zelf OPHALEN.",
    take_away_desc_retail: "Reserveer en haal op.",
    delivery: "Bezorgen",
    delivery_desc: "We bezorgen bij u thuis.",
    delivery_desc_retail: "Verzending naar adres.",
    not_available: "Niet beschikbaar",
    suspended: "GESCHORST",
    temp_unavailable: "TIJDELIJK NIET BESCHIKBAAR", 
    closed_msg: "We zijn gesloten",
    closed_desc: "Gesloten op dit moment.",
    browse_menu: "Bekijk menu",
    browse_catalog: "Bekijk catalogus",
    choose_menu_title: "Kies uw menu",
    choose_catalog_title: "Onze catalogus",
    address_title: "Waar bezorgen we?",
    address_title_retail: "Verzendadres?",
    address_step1: "Stap 1: Straat",
    address_step2: "Stap 2: Plaats",
    address_step3: "Stap 3: Huisnummer",
    next: "Volgende",
    confirm_address: "Adres Bevestigen",
    verifying: "Controleren...",
    address_confirmed: "Bevestigd!",
    delivery_cost: "Bezorgkosten",
    shipping_cost: "Verzendkosten",
    min_order: "Min. Bestelling",
    go_to_menu: "Menu",
    go_to_catalog: "Catalogus",
    out_of_zone: "Buiten gebied",
    out_of_zone_desc: "Adres buiten bezorggebied.",
    close: "Sluiten",
    confirm: "Bevestigen",
    cancel: "Annuleren",
    wait_time: "Wachttijd",
    warning: "Waarschuwing",
    warning_takeaway: "GEEN thuisbezorging.",
    supplement: "Toeslag",
    send_msg: "Bericht versturen",
    write_us: "Schrijf ons",
    your_name: "Uw naam",
    your_phone: "Telefoon",
    order_id_opt: "Bestellings-ID (Optioneel)",
    msg_placeholder: "Bericht...",
    msg_warn: "Nummer vereist voor antwoord!",
    kiosk_mode: "Kiosk",
    confirm_removal: "Verwijderen bevestigen",
    confirm_removal_message: "{item} verwijderen?",
    cart_title: "Winkelwagen",
    cart_empty: "Leeg",
    start_ordering: "Bestellen",
    promo_code: "Kortingscode",
    apply: "Toepassen",
    coupon_applied: "Code toegepast!",
    shipping: "Verzending",
    free: "Gratis",
    total_order: "Totaal Bestelling",
    proceed: "Doorgaan",
    who_orders: "Naam",
    table_number: "Tafel",
    payment_method: "Betaalmethode",
    kitchen_notes: "Opmerkingen",
    kitchen_notes_placeholder: "Bv. Geen uien...",
    send_order: "Versturen",
    add: "Toevoegen",
    update: "Bijwerken",
    total: "Totaal",
    how_to_serve: "Manier van serveren?",
    serve_desc: "Kies hoe u dit wenst.",
    plate: "Op bord",
    disposable: "Meeneembox",
    best_sellers: "Bestverkocht",
    quick_add: "Snel Toevoegen",
    order_again: "Opnieuw bestellen",
    search_products: "Zoeken...",
    search_results: "Resultaten",
    no_results: "Geen resultaten.",
    discover: "Ontdek",
    scroll_for_ingredients: "Scroll voor beleg",
    max_ingredients_limit: "Max {count} varianten!",
    combination_applied: "Toegepast!",
    order_updated: "Bestelling bijgewerkt!",
    item_added: "{item} toegevoegd!",
    added_label: "Toegevoegd: {item}",
    receipt_copy: "Kopie",
    receipt_payment: "BETALING",
    receipt_table: "TAFEL",
    receipt_takeaway: "AFHALEN",
    receipt_delivery: "BEZORGEN",
    receipt_notes: "Opmerkingen",
    without: "ZONDER",
    loyalty_title: "{value} Korting!",
    loyalty_reward_badge: "BELONING",
    loyalty_desc: "Spaar punten!",
    loyalty_card_info: "Uw nummer is de spaarkaart",
    super_reward_active: "{title} Actief!",
    super_reward_days_left: "Nog {days} dagen.",
    expires_on: "Vervalt op",
    goal: "Doel",
    points_progress: "Punten",
    points_missing: "Nog {points} punten nodig!",
    goal_reached: "Doel bereikt!",
    promo_code_label: "CODE",
    retail_pickup: "Ophalen",
    retail_delivery: "Bezorging",
    loyalty_enter_number: "Spaar punten!",
    super_reward_default: "Super Beloning",
    check_points_btn: "Bekijk Saldo",
    check_points_modal_title: "Nummer",
    check_points_modal_desc: "Controleer met uw telefoonnummer.",
    check_points_verify: "Controleren",
    check_points_verifying: "Laden...",
    check_points_error_invalid: "Ongeldig",
    check_points_error_not_found: "Niet gevonden.",
    loyalty_prompt_title: "Mis geen punten! 🎁",
    loyalty_prompt_desc: "Spaar punten.",
    loyalty_your_phone_placeholder: "Uw telefoonnummer",
    loyalty_points_balance: "U heeft {points} pt!",
    loyalty_super_reward_btn: "Activeer Beloning",
    free_product: "Gratis Product",
    added_to_cart: "In winkelmand",
    loyalty_discount: "Korting",
    points_redeemed: "Muntjes ingewisseld",
    points_earned: "Muntjes verdiend",
    loyalty_balance: "Saldo",
    loyalty_rule_spend: "Elke {amount}€=1pt.",
    loyalty_rule_order: "{amount} pt per bestelling.",
    loyalty_claim_reward: "{amount}pt=Beloning!",
    wrong_address_warning: "Let op adres.",
    marketing_btn: "Aanbiedingen",
    whats_new: "Nieuwtjes",
    marketing_offer: "Aanbieding",
    marketing_offers: "Aanbiedingen",
    marketing_news: "Nieuws",
    no_variants_title: "Geen varianten",
    no_variants_desc: "Geen varianten toevoegen?",
    marketing_special_offer: "Speciale aanbieding",
    marketing_featured_products: "Aanbevolen",
    marketing_get_discount: "Pak Korting",
    marketing_order_now: "Nu Bestellen",
    marketing_discount_applied: "Korting ({code}) in kassa.",
    marketing_add_cart: "Toevoegen",
    // EXTENDED MISSING STRINGS
    my_orders: "Mijn Bestellingen",
    my_orders_desc: "Overzicht van uw recente bestellingen bij deze zaak.",
    my_orders_loading: "Bestellingen laden...",
    my_orders_empty: "Geen recente bestellingen gevonden op dit apparaat.",
    order_num: "Bestelling #{id}",
    reorder: "Opnieuw Bestellen",
    edit_order_time_limit: "Bestelling Wijzigen (Binnen 3 min)",
    reorder_modal_title: "Kies Bestelwijze",
    reorder_modal_desc: "Hoe wilt u uw bestelling ontvangen?",
    order_status_completed: "Afgerond",
    order_status_cancelled: "Geannuleerd",
    order_status_delivering: "Onderweg",
    order_status_preparing: "In Bereiding",
    context_delivery: "Bezorgen",
    context_takeaway: "Afhalen",
    context_dinein: "Aan tafel",
    go_to_cart: "Naar Winkelmand",
    cart_subtotal: "Subtotaal",
    cart_delivery_fee: "Bezorging",
    surge_fee: "Feestdag- / Piekuurtoeslag",
    takeaway_fee: "Afhaaltoeslag",
    small_order_fee: "Toeslag Klein Orderbedrag",
    app_discount_label: "App-Korting",
    promo_quantity_discount_label: "Aantalskorting Actie",
    items_count: "({count} items)",
    points_earned_badge: "+{points} Punten",
    update_order_btn: "Bestelling Bijwerken",
    free_delivery_super_reward: "Gratis Bezorging (Super Beloning)",
    mandatory_choice_alert: "⚠️ VERPLICHTE KEUZE\n\nU moet minstens {quantity} {category} selecteren.\nNog ontbrekend: {missing}.",
    missing_free_title: "Gratis Opties Beschikbaar",
    missing_free_desc: "Dit artikel bevat gratis opties die u niet heeft gekozen ({categories}). Wilt u er alsnog toevoegen of doorgaan zonder?",
    name_modal_title: "Wat is uw naam?",
    name_modal_desc: "Voer uw naam in voor de bestelling.",
    name_modal_placeholder: "Uw naam...",
    intercom_modal_title: "Bezorgdetails",
    intercom_modal_desc: "Voer naam op bel, portiek of verdieping in.",
    intercom_modal_placeholder: "Bijv. Bel Jansen, 2e verdieping...",
    phone_modal_title_mandatory: "Telefoonnummer",
    phone_modal_title_optional: "Mobiel Nummer (Aanbevolen)",
    phone_modal_desc_mandatory: "Vereist voor bezorging of betaallink.",
    phone_modal_desc_optional: "Indien overgeslagen ontvangt u geen gereed-melding en loopt u spaarpunten mis!",
    phone_modal_confirm_btn: "Nummer Bevestigen",
    phone_modal_skip_btn: "Doorgaan zonder nummer (Geen punten)",
    birthday_modal_title: "Wanneer bent u jarig?",
    birthday_modal_desc: "Vul dag en maand in om een cadeautje te ontvangen!",
    birthday_modal_gdpr: "(Wegens privacy slaan we geen geboortejaar op)",
    birthday_modal_skip_btn: "Overslaan",
    privacy_modal_title: "Laatste stap!",
    privacy_modal_desc: "Accepteer het privacybeleid om verder te gaan.",
    privacy_checkbox_text: "Ik heb het privacybeleid gelezen en ga akkoord met de",
    privacy_checkbox_mandatory: "(Verplicht)",
    privacy_marketing_text: "Exclusieve aanbiedingen en kortingen ontvangen? (Optioneel)",
    privacy_confirm_btn: "Bevestigen en Bestellen",
    privacy_error_alert: "U dient akkoord te gaan met het privacybeleid om door te gaan.",
    payment_method_title: "Betaalmethode",
    payment_method_desc: "Hoe wilt u betalen?",
    payment_cash: "Contant",
    payment_cash_delivery: "Contant bij bezorging",
    payment_cash_pickup: "Betalen bij afhalen",
    payment_pos_delivery: "Pinautomaat (Bij bezorging)",
    payment_pos_store: "Pinautomaat / Kassa",
    payment_pos_link: "Pinautomaat / Betaallink",
    payment_disabled_badge: "Uitgeschakeld"
  },
  cz: {
    no_rider_found: "Žádný Rider nepřijal objednávku do 30 minut. Můžete zkusit odeslat požadavek znovu nebo jej zpracovat interně.",
    status_open: "Otevřeno",
    status_closed: "Zavřeno",
    closed_extra: "Extra uzavřeno", 
    loading: "Načítání...",
    hours: "Hodiny",
    about: "O nás",
    contact: "Kontakt",
    store_location: "Poloha pobočky",
    events: "Události",
    dine_in: "Na místě",
    dine_in_desc: "Objednávka ke stolu.",
    dine_in_desc_retail: "Služba na místě.",
    take_away: "S sebou",
    take_away_desc: "Objednávka k vyzvednutí.",
    take_away_desc_retail: "Rezervovat a vyzvednout.",
    delivery: "Doručení",
    delivery_desc: "Doručíme vaši objednávku.",
    delivery_desc_retail: "Odeslání na adresu.",
    not_available: "Nedostupné",
    suspended: "POZASTAVENO",
    temp_unavailable: "DOČASNĚ NEDOSTUPNÉ", 
    closed_msg: "Máme zavřeno",
    closed_desc: "Nyní je zavřeno.",
    browse_menu: "Zobrazit menu",
    browse_catalog: "Zobrazit katalog",
    choose_menu_title: "Vyberte si menu",
    choose_catalog_title: "Náš katalog",
    address_title: "Kam doručit?",
    address_title_retail: "Doručovací adresa?",
    address_step1: "Krok 1: Ulice",
    address_step2: "Krok 2: Město",
    address_step3: "Krok 3: Číslo popisné",
    next: "Další",
    confirm_address: "Potvrdit adresu",
    verifying: "Ověřování...",
    address_confirmed: "Úspěch!",
    delivery_cost: "Cena doručení",
    shipping_cost: "Doprava",
    min_order: "Min. objednávka",
    go_to_menu: "Do menu",
    go_to_catalog: "Do katalogu",
    out_of_zone: "Mimo zónu",
    out_of_zone_desc: "Adresa je mimo oblast doručení.",
    close: "Zavřít",
    confirm: "Potvrdit",
    cancel: "Zrušit",
    wait_time: "Čas čekání",
    warning: "Varování",
    warning_takeaway: "NENÍ to doručení na dům.",
    supplement: "Doplatek",
    send_msg: "Poslat zprávu",
    write_us: "Napište nám",
    your_name: "Vaše jméno",
    your_phone: "Telefon",
    order_id_opt: "Číslo obj. (Volitelné)",
    msg_placeholder: "Zpráva...",
    msg_warn: "Potřebujeme číslo pro odpověď!",
    kiosk_mode: "Kiosek",
    confirm_removal: "Potvrdit",
    confirm_removal_message: "Odstranit {item}?",
    cart_title: "Košík",
    cart_empty: "Prázdný",
    start_ordering: "Začít",
    promo_code: "Poukázka",
    apply: "Použít",
    coupon_applied: "Aplikováno!",
    shipping: "Doprava",
    free: "Zdarma",
    total_order: "Celkem",
    proceed: "Pokračovat",
    who_orders: "Jméno",
    table_number: "Stůl",
    payment_method: "Platba",
    kitchen_notes: "Poznámky pro kuchyň",
    kitchen_notes_placeholder: "Např. bez cibule...",
    send_order: "Odeslat objednávku",
    add: "Přidat",
    update: "Aktualizovat",
    total: "Celkem",
    how_to_serve: "Servírování?",
    serve_desc: "Jak si přejete doručit.",
    plate: "Na talíři",
    disposable: "S sebou box",
    best_sellers: "Oblíbené",
    quick_add: "Rychlé přidání",
    order_again: "Objednat znovu",
    search_products: "Hledat...",
    search_results: "Výsledky",
    no_results: "Nic nenalezeno.",
    discover: "Objevit",
    scroll_for_ingredients: "Sjeďte pro suroviny",
    max_ingredients_limit: "Max {count}!",
    combination_applied: "Přidáno!",
    order_updated: "Aktualizováno!",
    item_added: "{item} přidán!",
    added_label: "Přidáno: {item}",
    receipt_copy: "Kopie",
    receipt_payment: "PLATBA",
    receipt_table: "STŮL",
    receipt_takeaway: "S SEBOU",
    receipt_delivery: "DORUČENÍ",
    receipt_notes: "Poznámky",
    without: "BEZ",
    loyalty_title: "Sleva {value}!",
    loyalty_reward_badge: "ODMĚNA",
    loyalty_desc: "Získávejte body!",
    loyalty_card_info: "Vaše číslo = karta",
    super_reward_active: "{title} Aktivní!",
    super_reward_days_left: "Ještě {days} dnů.",
    expires_on: "Platí do",
    goal: "Cíl",
    points_progress: "Body",
    points_missing: "Chybí {points} bodů!",
    goal_reached: "Dosaženo!",
    promo_code_label: "KÓD",
    retail_pickup: "Vyzvednutí",
    retail_delivery: "Doručení",
    loyalty_enter_number: "Sbírejte body!",
    super_reward_default: "Super Odměna",
    check_points_btn: "Zkontrolovat body",
    check_points_modal_title: "Číslo",
    check_points_modal_desc: "Ověřte své telefonní číslo.",
    check_points_verify: "Ověřit",
    check_points_verifying: "Načítání...",
    check_points_error_invalid: "Neplatné",
    check_points_error_not_found: "Nenalezeno.",
    loyalty_prompt_title: "Body čekají! 🎁",
    loyalty_prompt_desc: "Získejte odměny.",
    loyalty_your_phone_placeholder: "Váš telefon",
    loyalty_points_balance: "Máte {points} bodů!",
    loyalty_super_reward_btn: "Aktivovat odměnu",
    free_product: "Zdarma",
    added_to_cart: "V košíku",
    loyalty_discount: "Sleva",
    points_redeemed: "Použité body",
    points_earned: "Získané body",
    loyalty_balance: "Zůstatek",
    loyalty_rule_spend: "{amount}Kč=1b.",
    loyalty_rule_order: "{amount}b/obj.",
    loyalty_claim_reward: "{amount}b=Odměna!",
    wrong_address_warning: "Dejte pozor na adresu.",
    marketing_btn: "Akce",
    whats_new: "Novinky",
    marketing_offer: "Akce",
    marketing_offers: "Akce",
    marketing_news: "Novinka",
    no_variants_title: "Bez variant",
    no_variants_desc: "Bez doplňků?",
    marketing_special_offer: "Speciální akce",
    marketing_featured_products: "Doporučené",
    marketing_get_discount: "Získat slevu",
    marketing_order_now: "Objednat",
    marketing_discount_applied: "Sleva v košíku.",
    marketing_add_cart: "Přidat",
    // EXTENDED MISSING STRINGS
    my_orders: "Moje Objednávky",
    my_orders_desc: "Historie vašich nedávných objednávek v tomto podniku.",
    my_orders_loading: "Načítání objednávek...",
    my_orders_empty: "Na tomto zařízení nebyly nalezeny žádné nedávné objednávky.",
    order_num: "Objednávka #{id}",
    reorder: "Objednat Znovu",
    edit_order_time_limit: "Upravit Objednávku (Do 3 min)",
    reorder_modal_title: "Zvolte Způsob",
    reorder_modal_desc: "Jak si přejete objednávku převzít?",
    order_status_completed: "Dokončeno",
    order_status_cancelled: "Zrušeno",
    order_status_delivering: "Na Cestě",
    order_status_preparing: "V Přípravě",
    context_delivery: "Doručení",
    context_takeaway: "S sebou",
    context_dinein: "Na místě",
    go_to_cart: "Do Košíku",
    cart_subtotal: "Mezisoučet",
    cart_delivery_fee: "Doručení",
    surge_fee: "Příplatek za Špičku / Svátky",
    takeaway_fee: "Příplatek S sebou",
    small_order_fee: "Příplatek za Malou Objednávku",
    app_discount_label: "Sleva v Aplikaci",
    promo_quantity_discount_label: "Množstevní Sleva",
    items_count: "({count} ks)",
    points_earned_badge: "+{points} Bodů",
    update_order_btn: "Aktualizovat Objednávku",
    free_delivery_super_reward: "Doručení Zdarma (Super Odměna)",
    mandatory_choice_alert: "⚠️ POVINNÝ VÝBĚR\n\nMusíte vybrat alespoň {quantity} {category}.\nChybí: {missing}.",
    missing_free_title: "Bezplatné Možnosti K Dispozici",
    missing_free_desc: "Tato položka obsahuje bezplatné možnosti ({categories}), které jste nevybrali. Chcete je přidat, nebo pokračovat bez nich?",
    name_modal_title: "Jak se jmenujete?",
    name_modal_desc: "Zadejte své jméno pro objednávku.",
    name_modal_placeholder: "Vaše jméno...",
    intercom_modal_title: "Detaily Doručení",
    intercom_modal_desc: "Zadejte jméno na zvonku, patro nebo vchod.",
    intercom_modal_placeholder: "Např. Zvonek Novák, 2. patro...",
    phone_modal_title_mandatory: "Telefonní Číslo",
    phone_modal_title_optional: "Telefonní Číslo (Doporučeno)",
    phone_modal_desc_mandatory: "Vyžadováno pro doručení nebo zaslání platebního odkazu.",
    phone_modal_desc_optional: "Pokud přeskočíte, neobdržíte notifikaci o vyřízení a přijdete o věrnostní body!",
    phone_modal_confirm_btn: "Potvrdit Číslo",
    phone_modal_skip_btn: "Pokračovat bez čísla (Bez bodů)",
    birthday_modal_title: "Kdy máte narozeniny?",
    birthday_modal_desc: "Zadejte den a měsíc a získejte dárek!",
    birthday_modal_gdpr: "(Kvůli GDPR neukládáme rok narození)",
    birthday_modal_skip_btn: "Přeskočit",
    privacy_modal_title: "Poslední krok!",
    privacy_modal_desc: "Pro pokračování je nutné souhlasit se zásadami ochrany osobních údajů.",
    privacy_checkbox_text: "Přečetl(a) jsem a souhlasím se",
    privacy_checkbox_mandatory: "(Povinné)",
    privacy_marketing_text: "Zasílat speciální nabídky a slevy? (Volitelné)",
    privacy_confirm_btn: "Potvrdit a Objednat",
    privacy_error_alert: "Pro pokračování musíte souhlasit se zásadami ochrany osobních údajů.",
    payment_method_title: "Způsob Platby",
    payment_method_desc: "Jak si přejete zaplatit?",
    payment_cash: "Hotovost",
    payment_cash_delivery: "Hotově při doručení",
    payment_cash_pickup: "Platba při převzetí",
    payment_pos_delivery: "Platební Terminál (Při doručení)",
    payment_pos_store: "Terminál / Pokladna",
    payment_pos_link: "Terminál / Platební Odkaz",
    payment_disabled_badge: "Deaktivováno"
  },
  hr: {
    no_rider_found: "Nijedan Rider nije prihvatio narudžbu u roku od 30 minuta. Možete pokušati ponovno poslati zahtjev ili ga riješiti interno.",
    status_open: "Otvoreno",
    status_closed: "Zatvoreno",
    closed_extra: "Izvanredno zatvoreno", 
    loading: "Učitavanje...",
    hours: "Radno vrijeme",
    about: "O nama",
    contact: "Kontakt",
    store_location: "Lokacija",
    events: "Događaji",
    dine_in: "Ovdje jedi",
    dine_in_desc: "Naručujete za stol.",
    dine_in_desc_retail: "Usluga na lokaciji.",
    take_away: "Za van",
    take_away_desc: "Dolazite PO NARUDŽBU.",
    take_away_desc_retail: "Rezervirajte i pokupite.",
    delivery: "Dostava",
    delivery_desc: "Dostavit ćemo vašu narudžbu.",
    delivery_desc_retail: "Slanje na adresu.",
    not_available: "Nije dostupno",
    suspended: "OBustavljeno",
    temp_unavailable: "TRENUTNO NEDOSTUPNO", 
    closed_msg: "Zatvoreni smo",
    closed_desc: "Trenutno je zatvoreno.",
    browse_menu: "Pogledaj meni",
    browse_catalog: "Pogledaj katalog",
    choose_menu_title: "Odaberite meni",
    choose_catalog_title: "Naš katalog",
    address_title: "Gdje dostavljamo?",
    address_title_retail: "Adresa dostave?",
    address_step1: "Korak 1: Ulica",
    address_step2: "Korak 2: Grad",
    address_step3: "Korak 3: Kućni broj",
    next: "Dalje",
    confirm_address: "Potvrdi",
    verifying: "Provjera...",
    address_confirmed: "Potvrđeno!",
    delivery_cost: "Cijena dostave",
    shipping_cost: "Dostava",
    min_order: "Min. narudžba",
    go_to_menu: "Meni",
    go_to_catalog: "Katalog",
    out_of_zone: "Izvan zone",
    out_of_zone_desc: "Adresa je izvan zone dostave.",
    close: "Zatvori",
    confirm: "Potvrdi",
    cancel: "Odustani",
    wait_time: "Čekanje",
    warning: "Upozorenje",
    warning_takeaway: "NIJE narudžba za dostavu.",
    supplement: "Nadoplata",
    send_msg: "Pošalji poruku",
    write_us: "Pišite nam",
    your_name: "Vaše ime",
    your_phone: "Telefon",
    order_id_opt: "ID narudžbe (Opcija)",
    msg_placeholder: "Poruka...",
    msg_warn: "Trebamo broj za odgovor!",
    kiosk_mode: "Kiosk",
    confirm_removal: "Potvrdi",
    confirm_removal_message: "Ukloniti {item}?",
    cart_title: "Košarica",
    cart_empty: "Prazna",
    start_ordering: "Započni narudžbu",
    promo_code: "Promo kod",
    apply: "Primijeni",
    coupon_applied: "Primijenjeno!",
    shipping: "Dostava",
    free: "Besplatno",
    total_order: "Trenutno ukupno",
    proceed: "Nastavi",
    who_orders: "Ime",
    table_number: "Stol",
    payment_method: "Plaćanje",
    kitchen_notes: "Napomene za kuhinju",
    kitchen_notes_placeholder: "Npr. bez majoneze...",
    send_order: "Pošalji",
    add: "Dodaj",
    update: "Ažuriraj",
    total: "Ukupno",
    how_to_serve: "Kako poslužiti?",
    serve_desc: "Odaberite preferenciju.",
    plate: "Na tanjuru",
    disposable: "Za van pakiranje",
    best_sellers: "Najprodavanije",
    quick_add: "Brzo dodavanje",
    order_again: "Naruči ponovo",
    search_products: "Traži...",
    search_results: "Rezultati",
    no_results: "Nema rezultata.",
    discover: "Otkrijte",
    scroll_for_ingredients: "Skrolaj za sastojke",
    max_ingredients_limit: "Maks {count}!",
    combination_applied: "Dodano!",
    order_updated: "Ažurirano!",
    item_added: "{item} dodan!",
    added_label: "Dodano: {item}",
    receipt_copy: "Kopija",
    receipt_payment: "PLAĆANJE",
    receipt_table: "STOL",
    receipt_takeaway: "ZA VAN",
    receipt_delivery: "DOSTAVA",
    receipt_notes: "Napomene",
    without: "BEZ",
    loyalty_title: "Popust {value}!",
    loyalty_reward_badge: "NAGRADA",
    loyalty_desc: "Sakupljajte bodove!",
    loyalty_card_info: "Vaš broj = kartica",
    super_reward_active: "{title} Aktivno!",
    super_reward_days_left: "Još {days} dana.",
    expires_on: "Vrijedi do",
    goal: "Cilj",
    points_progress: "Bodovi",
    points_missing: "Nedostaje {points} bodova!",
    goal_reached: "Ostvareno!",
    promo_code_label: "KOD",
    retail_pickup: "Osobno preuzimanje",
    retail_delivery: "Dostava",
    loyalty_enter_number: "Skupljajte bodove!",
    super_reward_default: "Super Nagrada",
    check_points_btn: "Provjeri stanje",
    check_points_modal_title: "Broj",
    check_points_modal_desc: "Unesite vaš broj mobitela.",
    check_points_verify: "Provjeri",
    check_points_verifying: "Učitavanje...",
    check_points_error_invalid: "Nevažeće",
    check_points_error_not_found: "Nije pronađeno.",
    loyalty_prompt_title: "Bodovi vas čekaju! 🎁",
    loyalty_prompt_desc: "Zaradite nagrade.",
    loyalty_your_phone_placeholder: "Vaš broj mobitela",
    loyalty_points_balance: "Imate {points} bodova!",
    loyalty_super_reward_btn: "Aktiviraj nagradu",
    free_product: "Besplatni proizvod",
    added_to_cart: "U košarici",
    loyalty_discount: "Popust",
    points_redeemed: "Iskorišteno",
    points_earned: "Zaradeno",
    loyalty_balance: "Stanje",
    loyalty_rule_spend: "{amount}€=1bod.",
    loyalty_rule_order: "{amount}b po narudžbi.",
    loyalty_claim_reward: "{amount}b=Nagrada!",
    wrong_address_warning: "Upozorenje za adresu.",
    marketing_btn: "Ponude i novosti",
    whats_new: "Izdvajamo",
    marketing_offer: "Ponuda",
    marketing_offers: "Ponude",
    marketing_news: "Novost",
    no_variants_title: "Bez dodataka",
    no_variants_desc: "Sigurno bez dodataka?",
    marketing_special_offer: "Specijalna ponuda",
    marketing_featured_products: "Izdvojeno",
    marketing_get_discount: "Preuzmi popust",
    marketing_order_now: "Naruči odmah",
    marketing_discount_applied: "Popust ({code})",
    marketing_add_cart: "Kupi",
    // EXTENDED MISSING STRINGS
    my_orders: "Moje Narudžbe",
    my_orders_desc: "Povijest vaših nedavnih narudžbi u ovom objektu.",
    my_orders_loading: "Učitavanje narudžbi...",
    my_orders_empty: "Nema nedavnih narudžbi na ovom uređaju.",
    order_num: "Narudžba #{id}",
    reorder: "Naruči Ponovno",
    edit_order_time_limit: "Uredi Narudžbu (Unutar 3 min)",
    reorder_modal_title: "Odaberite Način",
    reorder_modal_desc: "Kako želite primiti svoju narudžbu?",
    order_status_completed: "Dovršeno",
    order_status_cancelled: "Otkazano",
    order_status_delivering: "U Dostavi",
    order_status_preparing: "U Pripremi",
    context_delivery: "Dostava",
    context_takeaway: "Za Van",
    context_dinein: "Ovdje",
    go_to_cart: "Idi u Košaricu",
    cart_subtotal: "Međuzbroj",
    cart_delivery_fee: "Dostava",
    surge_fee: "Nadoplata za Praznike / Vrhunac",
    takeaway_fee: "Nadoplata Za Van",
    small_order_fee: "Nadoplata za Minimalnu Narudžbu",
    app_discount_label: "Popust Aplikacije",
    promo_quantity_discount_label: "Količinski Popust",
    items_count: "({count} stavki)",
    points_earned_badge: "+{points} Bodova",
    update_order_btn: "Ažuriraj Narudžbu",
    free_delivery_super_reward: "Besplatna Dostava (Super Nagrada)",
    mandatory_choice_alert: "⚠️ OBVEZAN ODABIR\n\nMorate odabrati najmanje {quantity} {category}.\nNedostaje: {missing}.",
    missing_free_title: "Dostupne Besplatne Opcije",
    missing_free_desc: "Ovaj proizvod uključuje besplatne opcije koje niste odabrali ({categories}). Želite li ih dodati ili nastaviti bez njih?",
    name_modal_title: "Kako se zovete?",
    name_modal_desc: "Unesite svoje ime za narudžbu.",
    name_modal_placeholder: "Vaše ime...",
    intercom_modal_title: "Detalji Dostave",
    intercom_modal_desc: "Unesite ime na portafonu, ulaz ili kat.",
    intercom_modal_placeholder: "Npr. Portafon Horvat, 2. kat...",
    phone_modal_title_mandatory: "Broj Mobitela",
    phone_modal_title_optional: "Broj Mobitela (Preporučeno)",
    phone_modal_desc_mandatory: "Potrebno za dostavu ili poveznicu za plaćanje.",
    phone_modal_desc_optional: "Ako preskočite, nećete primiti obavijest o spremnosti i gubite bodove vjernosti!",
    phone_modal_confirm_btn: "Potvrdi Broj",
    phone_modal_skip_btn: "Nastavi bez broja (Bez bodova)",
    birthday_modal_title: "Kada vam je rođendan?",
    birthday_modal_desc: "Unesite dan i mjesec kako biste primili poklon!",
    birthday_modal_gdpr: "(Zbog GDPR-a ne prikupljamo godinu rođenja)",
    birthday_modal_skip_btn: "Preskoči",
    privacy_modal_title: "Zadnji korak!",
    privacy_modal_desc: "Za nastavak morate prihvatiti politiku privatnosti.",
    privacy_checkbox_text: "Pročitao/la sam i prihvaćam",
    privacy_checkbox_mandatory: "(Obavezno)",
    privacy_marketing_text: "Primati ekskluzivne ponude i popuste? (Neobavezno)",
    privacy_confirm_btn: "Potvrdi i Naruči",
    privacy_error_alert: "Morate prihvatiti politiku privatnosti za nastavak.",
    payment_method_title: "Način Plaćanja",
    payment_method_desc: "Kako želite platiti?",
    payment_cash: "Gotovina",
    payment_cash_delivery: "Gotovina pri dostavi",
    payment_cash_pickup: "Plaćanje pri preuzimanju",
    payment_pos_delivery: "POS Terminal (Pri dostavi)",
    payment_pos_store: "POS / Blagajna",
    payment_pos_link: "POS / Poveznica za Plaćanje",
    payment_disabled_badge: "Onemogućeno"
  }
};
